import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  memo,
  useImperativeHandle,
} from "react";
import {
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  CardBody,
  TabContent,
  TabPane,
  Spinner,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from "reactstrap";
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle,
} from "@hello-pangea/dnd";
import { Range, getTrackBackground, useThumbOverlap } from "react-range";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import classnames from "classnames";

import uploadIcon from "../assets/images/icons/whiteboard-fonction-feature-3.svg";
// import uploadSmallIcon from "../assets/images/icons/whiteboard-fonction-feature-3.svg";
import onerrorImg from "../assets/images/screen_icons/onerrorImg.svg";
import Delete from "../assets/images/icons/whiteboard-menu-c-3.svg";
import lightDelete from "../assets/images/icons/console-control-3.svg";
import close from "../assets/images/screen_icons/close.svg";
import notice from "../assets/images/icons/whiteboard-setting-1.svg";
import turnLeft from "../assets/images/icons/whiteboard-menu-c-4.svg";
import turnRight from "../assets/images/icons/whiteboard-menu-c-5.svg";
import textEdit from "../assets/images/icons/whiteboard-setting-2.svg";
import setting from "../assets/images/icons/console-6.svg";
import dots from "../assets/images/icons/console-2.svg";
import lock from "../assets/images/icons/console-12.svg";
import toTop from "../assets/images/icons/console-control-10.svg";
import toBottom from "../assets/images/icons/console-control-9.svg";
import item_dlt from "../assets/images/screen_icons/item_dlt.svg";
import item_copy from "../assets/images/icons/whiteboard-menu-b-5-2.svg";

import { Portal } from "../utils/components";
import { getAuthToken, getTeacherAuthToken } from "../utils/auth";
import { TEST_DATA } from "../utils/testData";

import ThemeSelect from "./common/ThemeSelect";
import RandomNameModule from "./common/RandomName";
import CardModule from "./common/Card";
import QRcodeModule from "./common/QRcode";
import ImageModule from "./common/Image";
import TextModule from "./common/Text";
import ReadModule from "./common/TextRead";
import TimerModule from "./common/Timer";
import WebcamModule from "./common/Webcam";
import ClockModule from "./common/Clock";
import CalendarModule from "./common/Calendar";
import TimeTableModule from "./common/TimeTable";
import GroupMakerModule from "./common/GroupMaker";
import StopwatchModule from "./common/Stopwatch";
import EmbedModule from "./common/Embed";
import VideoTimelineModule from "./common/VideoTimeline";
import EventCountdownModule from "./common/EventCountdown";
import HyperLinkModule from "./common/HyperLink";
import WorksModule from "./common/Works";
import DrawStrokeModule from "./common/DrawStroke";
import MindMapModule, { IframeComponentHandle } from "./common/MindMap";

import {
  dragMouseDown,
  resizeMouseDown,
  componentCheck,
  moveCheck,
  getUrlParameter,
  random,
  hideCheck,
} from "../utils/actions";

import {
  ImageListGetAction,
  MemberCreateAction,
  CardCreateAction,
  MemberListGetAction,
  CardListGetAction,
} from "../store/screen/actions";
import { screenState, setError } from "../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../store/hooks";

import widgetRandomName from "../assets/images/screen/WIDGET_RANDOM_NAME.svg";
import widgetQrCode from "../assets/images/screen/WIDGET_QR_CODE.svg";
import widgetImage from "../assets/images/screen/WIDGET_IMAGE.svg";
import widgetText from "../assets/images/screen/WIDGET_TEXT.svg";
import widgetDraw from "../assets/images/screen/WIDGET_DRAW.svg";
import widgetTimer from "../assets/images/screen/WIDGET_TIMER.svg";
import widgetClock from "../assets/images/screen/WIDGET_CLOCK.svg";
import widgetCalendar from "../assets/images/screen/WIDGET_CALENDAR.svg";
import widgetTimeTable from "../assets/images/icons/icon-timetable.svg";
import widgetGroupMaker from "../assets/images/screen/WIDGET_GROUP_MAKER.svg";
import widgetStopwatch from "../assets/images/screen/WIDGET_STOPWATCH.svg";
import widgetWebcam from "../assets/images/screen/WIDGET_WEBCAM.png";
import widgetEmbed from "../assets/images/screen/WIDGET_EMBED.svg";
import widgetVideoTimeline from "../assets/images/screen/WIDGET_VIDEO_TIMELINE.svg";
import widgetEventCountdown from "../assets/images/screen/WIDGET_EVENT_COUNTDOWN.svg";
import widgetHyperlink from "../assets/images/screen/WIDGET_HYPERLINK.svg";
import zIndex from "@mui/material/styles/zIndex";
import { transform } from "lodash";

const BaseBlock = (props: any) => {
  const {
    localRef,
    selfDisplay,
    itemIndex,
    screenData,
    status,
    nowPage,
    scale,
    groupSelect,
    onUpdate,
    actionEnd,
    onLock,
    onUpDown,
    selectedList,
    selectedZone,
    setSelectedList,
    setSelectedZone,
    getWorksData,
    setImageSchedule,
    setImageScheduleCount,
    setEditId,
    copyItem,
    toolSwitch,
    jobType,
    userPermission,
    setCanCopy,
    socketRequest,
    boardInfoId,
    holdThisBox,
    setHoldThisBox,

    hoverCard,

    drawSetting,
    setCursorItem,
  } = props;
  const dispatch = useAppDispatch();
  const { username, images, members, cards, works } = useAppSelector(state =>
    screenState(state),
  );
  const [errorAlert, setErrorAlert] = useState<boolean>(false);
  const [Theme, setTheme] = useState(props.data.theme ?? "theme1");
  const [SetPending, setSetPending] = useState<boolean>(false);
  const [cardHeaderTab, setcardHeaderTab] = useState<string>("ChooseList");
  const [inputValue, setInputValue] = useState(
    props.data.data?.nameList ? props.data.data?.nameList.join("\n") : "",
  );
  const [cardTitle, setCardTitle] = useState("");
  const [cardValue, setCardValue] = useState("");
  const [recordThis, setRecordThis] = useState<boolean>(false);
  const [codeValue, setCodeValue] = useState(
    props.data.data?.codeStr ? props.data.data?.codeStr : "",
  );
  const [insideSwitch, setInsideSwitch] = useState<boolean>(false);
  const listRef = useRef<HTMLTextAreaElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [optionImg, setOptionImg] = useState<any>(null);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [isCountdownOpen, setIsCountdownOpen] = useState<boolean>(false);
  const [isCardOpen, setIsCardOpen] = useState<boolean>(false);
  const [Writing, setWriting] = useState<string>(
    props.data.data?.writing !== "" ? props.data.data?.writing : "Horizontal",
  );
  const [showFontSettings, setShowFontSettings] = useState<boolean>(
    props.data.selected,
  );
  const [worksData, setWorksData] = useState<any>([]);
  const [position, setPosition] = useState<any>({
    x: props.data.left,
    y: props.data.top,
  });
  const toolRef = useRef<any>(null);
  const popupRef = useRef<any>(null);
  const [sideDrag, setSideDrag] = useState<boolean>(false);
  const mobilePopupRef = useRef<any>(null);
  const insideRef = useRef<any>(null);
  const rangeRef: any = React.useRef<Range>();
  const [groups, setGroups] = useState<number>(
    props.data.data?.groups ? props.data.data?.groups : 1,
  );
  const [selected, setSelected] = useState<boolean>(props.data.selected);
  const [size, setSize] = useState<any>({
    width: props.data.width,
    height: props.data.height,
  });
  const [minSize, setMinSize] = useState<any>({
    minWidth: props.data.minWidth,
    minHeight: props.data.minHeight,
  });
  const [sideWidget, setSideWidget] = useState<boolean>(false);
  const [sideWidget2, setSideWidget2] = useState<boolean>(false);
  //
  const [lastTapTimestamp, setLastTapTimestamp] = useState(0);
  //
  const [destroyThis, setDestroyThis] = useState<boolean>(false);
  //
  const [FontSize, setFontSize] = useState<any>(
    props.data.data?.fontSize ? props.data.data?.fontSize : 24,
  );
  const [FontSpace, setFontSpace] = useState<any>(
    props.data.data?.fontSpace ? props.data.data?.fontSpace : 0,
  );
  //
  const marqueeRangeRef: any = React.useRef<Range>();
  const [IsMarquee, setIsMarquee] = useState<boolean>(
    props.data.data?.type === "marquee" ? true : false,
  );
  const [marqueeFontSize, setMarqueeFontSize] = useState(
    props.data.data?.marquee?.fontSize ? props.data.data?.marquee.fontSize : 20,
  );
  const [speed, setSpeed] = useState(
    props.data.data?.marquee?.speed ? props.data.data?.marquee.speed : 1,
  );
  //
  const iframeComponentRef = useRef<IframeComponentHandle>(null);
  const [mindMapEdit, setMindMapEdit] = useState<boolean>(
    props.data.data?.action === "edit" ? true : false,
  );
  //
  const [fitToImage, setFitToImage] = useState<boolean>(false);
  const [cooperate, setCooperate] = useState<boolean>(
    props.data.data?.cooperate,
  );
  //
  const [eventNameFontSize, setEventNameFontSize] = useState(
    props.data.data?.eventNameFontSize
      ? props.data.data?.eventNameFontSize
      : 30,
  );
  //
  const [countDownSecond, setCountDownSecond] = useState(
    props.data.data?.Countdown ? props.data.data?.Countdown : 5,
  );

  //
  useImperativeHandle({ current: localRef }, () => popupRef.current, [
    popupRef.current,
  ]);
  //

  let accessToken = "";
  let token = null;
  if (getAuthToken()) {
    token = getAuthToken();
  } else if (getTeacherAuthToken()) {
    token = getTeacherAuthToken();
  }
  if (token) {
    accessToken = token;
  }

  const StyleSet = (data: any) => {
    let HEIGHT = 0;
    let WIDTH = 0;
    const RATIO = data.width / data.height;
    const maxHeight = 1062;
    const maxWidth = 1902;
    if (data.spotlight) {
      if (data.type !== "WIDGET_CARD") {
        if (data.type !== "WIDGET_MIND_MAP") {
          if (RATIO === 1) {
            HEIGHT = maxHeight;
            WIDTH = HEIGHT * RATIO;
          } else {
            const heightCheck = maxWidth / RATIO >= maxHeight;
            const widthCheck = maxHeight * RATIO >= maxWidth;
            if (heightCheck) {
              HEIGHT = maxHeight;
              WIDTH = HEIGHT * RATIO;
            }
            if (widthCheck) {
              WIDTH = maxWidth;
              HEIGHT = WIDTH / RATIO;
            }
          }
        } else {
          WIDTH = maxWidth;
          HEIGHT = WIDTH / RATIO;
        }
      } else {
        HEIGHT = maxHeight;
        WIDTH = maxWidth;
      }
    } else {
      HEIGHT = data.height;
      WIDTH = data.width;
    }
    return {
      height: `${HEIGHT}px`,
      width: `${WIDTH}px`,
      position: `absolute`,
      top: `0px`,
      left: `0px`,
      zIndex: data.zIndex,
      transformOrigin: `left top`,
    } as const;
  };

  const resizeStyleSet = (data: any) => {
    if (!data.spotlight) {
      if (
        data.type !== "WIDGET_DRAW" &&
        props.data.type !== "WIDGET_TEXT" &&
        props.data.type !== "WIDGET_READ" &&
        data.type !== "WIDGET_GROUP_MAKER" &&
        data.type !== "WIDGET_WORKS" &&
        data.type !== "WIDGET_CARD"
      ) {
        return {
          height: `${data.height}px`,
          width: `${data.width}px`,
        } as const;
      } else {
        return {
          height: `${data.height}px`,
          width: `${data.width}px`,
        } as const;
      }
    }
  };

  const PositionSet = (data: any, position: any) => {
    let HEIGHT = 0;
    let WIDTH = 0;
    let Y = 0;
    let X = 0;
    const RATIO = data.width / data.height;
    const maxHeight = data.spotlight ? 1062 : 1080;
    const maxWidth = data.spotlight ? 1902 : 1920;
    if (data.spotlight) {
      if (data.type !== "WIDGET_CARD") {
        if (data.type !== "WIDGET_MIND_MAP") {
          if (RATIO === 1) {
            HEIGHT = maxHeight;
            WIDTH = HEIGHT * RATIO;
            Y = maxHeight / 2 - HEIGHT / 2;
            X = maxWidth / 2 - WIDTH / 2;
          } else {
            const heightCheck = maxWidth / RATIO >= maxHeight;
            const widthCheck = maxHeight * RATIO >= maxWidth;
            if (heightCheck) {
              HEIGHT = maxHeight;
              WIDTH = HEIGHT * RATIO;
              Y = maxHeight / 2 - HEIGHT / 2;
              X = maxWidth / 2 - WIDTH / 2;
            }
            if (widthCheck) {
              WIDTH = maxWidth;
              HEIGHT = WIDTH / RATIO;
              Y = maxHeight / 2 - HEIGHT / 2;
              X = maxWidth / 2 - WIDTH / 2;
            }
          }
        } else {
          Y = 0;
          X = 0;
        }
      } else {
        HEIGHT = maxHeight;
        WIDTH = HEIGHT * 1.791;
        Y = maxHeight / 2 - HEIGHT / 2;
        X = maxWidth / 2 - WIDTH / 2;
      }
    } else {
      Y = position.y;
      X = position.x;
    }

    return {
      top: Y + (data.spotlight ? 9 : 0),
      left: X + (data.spotlight ? 9 : 0),
    };
  };

  const itemSpotlight = () => {
    const root = document.getElementById("root");
    if (root) {
      if (root.classList.contains("spotlight")) {
        root.classList.remove("spotlight");
        onUpdate({ id: props.data.id, spotlight: false });
      } else {
        root.classList.add("spotlight");
        onUpdate({ id: props.data.id, spotlight: true });
      }
    }
  };

  const handleDoubleClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (target.closest('[data-double-click="false"]')) return;
    const currentTimestamp = Date.now();
    if (currentTimestamp - lastTapTimestamp < 300) {
      itemSpotlight();
    }
    setLastTapTimestamp(currentTimestamp);
  };

  useEffect(() => {
    onUpdate({ id: props.data.id, ...size });
  }, [size]);

  useEffect(() => {
    const { originTop, originLeft, top, left, oldScale } = props.data;
    setPosition({
      x: position.x,
      y: position.y,
    });
  }, [screenData]);

  useEffect(() => {
    if (props.data) {
      setPosition({
        x: props.data.originLeft,
        y: props.data.originTop,
      });
    }
  }, [props.data]);

  useEffect(() => {
    setSelected(props.data.selected);
    // setCurrentZIndex(props.data.toTop !== 0? props.data.toTop : props.data.zIndex);

    switch (props.data.type) {
      case "WIDGET_RANDOM_NAME":
        setOptionImg(widgetRandomName);
        break;
      case "WIDGET_QR_CODE":
        setOptionImg(widgetQrCode);
        break;
      case "WIDGET_IMAGE":
        setOptionImg(widgetImage);
        break;
      case "WIDGET_TEXT":
        setSideWidget(true);
        setOptionImg(widgetText);
        break;
      case "WIDGET_READ":
        setSideWidget(true);
        setOptionImg(widgetText);
        break;
      case "WIDGET_DRAW":
        setSideWidget(true);
        setOptionImg(widgetDraw);
        break;
      case "WIDGET_TIMER":
        setOptionImg(widgetTimer);
        break;
      case "WIDGET_CLOCK":
        setOptionImg(widgetClock);
        break;
      case "WIDGET_CALENDAR":
        setOptionImg(widgetCalendar);
        break;
      case "WIDGET_TIMETABLE":
        setSideWidget2(true);
        setOptionImg(widgetTimeTable);
        break;
      case "WIDGET_GROUP_MAKER":
        setOptionImg(widgetGroupMaker);
        break;
      case "WIDGET_STOPWATCH":
        setOptionImg(widgetStopwatch);
        break;
      case "WIDGET_WEBCAM":
        setOptionImg(widgetWebcam);
        break;
      case "WIDGET_EMBED":
        setOptionImg(widgetEmbed);
        break;
      case "WIDGET_VIDEO_TIMELINE":
        setOptionImg(widgetVideoTimeline);
        break;
      case "WIDGET_EVENT_COUNTDOWN":
        setOptionImg(widgetEventCountdown);
        break;
      case "WIDGET_HYPERLINK":
        setSideWidget2(true);
        setOptionImg(widgetHyperlink);
        break;
      case "WIDGET_WORKS":
        setSideWidget(true);
        setOptionImg(widgetText);
        break;
      case "WIDGET_CARD":
        setOptionImg(widgetRandomName);
        break;

      default:
        break;
    }

    if (props.data?.positionUpdated) {
      setPosition({
        x: props.data.originLeft,
        y: props.data.originTop,
      });
      delete props.data.positionUpdated;
    }

    if (Theme !== props.data.theme) {
      setTheme(props.data.theme);
    }
  }, [props.data]);

  useEffect(() => {
    if (props.data.selected) {
      setShowFontSettings(true);
    } else {
      closeOption();
      setShowFontSettings(false);
    }
  }, [props.data.selected]);

  const boxSizeSet = (boxData: any, base: any, side: string) => {
    const { height, width } = props.data;
    if (boxData.current) {
      let HEIGHT = 0;
      let WIDTH = 0;
      const RATIO = width / height;
      const maxHeight = 1062;
      const maxWidth = 1902;
      if (base.spotlight) {
        if (base.type !== "WIDGET_CARD") {
          if (base.type !== "WIDGET_MIND_MAP") {
            if (RATIO === 1) {
              HEIGHT = maxHeight;
              WIDTH = HEIGHT * RATIO;
            } else {
              const heightCheck = maxWidth / RATIO >= maxHeight;
              const widthCheck = maxHeight * RATIO >= maxWidth;
              if (heightCheck) {
                HEIGHT = maxHeight;
                WIDTH = HEIGHT * RATIO;
              }
              if (widthCheck) {
                WIDTH = maxWidth;
                HEIGHT = WIDTH / RATIO;
              }
            }
          } else {
            HEIGHT = maxHeight;
            WIDTH = maxWidth;
          }
        } else {
          HEIGHT = maxHeight;
          WIDTH = HEIGHT * 1.791;
        }
      } else {
        HEIGHT = height;
        WIDTH = width;
      }

      if (side === "outside") {
        return { height: HEIGHT, width: WIDTH };
      } else if (side === "inside") {
        if (base.type === "WIDGET_EMBED") {
          return { height: HEIGHT, width: WIDTH };
        } else if (base.type === "WIDGET_MIND_MAP") {
          if (
            (!username && !mindMapEdit) ||
            (username &&
              base.data.action !== "edit" &&
              base.data.cooperate !== 1)
          ) {
            const calculatedRatio = HEIGHT / base.baseHeight;
            const calculatedWidth = WIDTH / calculatedRatio;
            return {
              height: base.baseHeight,
              width: calculatedWidth,
              transform: `scale(${calculatedRatio})`,
            };
          } else {
            return { height: HEIGHT, width: WIDTH };
          }
        } else if (base.type === "WIDGET_TIMETABLE") {
          if (base.data.timeTable.length !== 0) {
            const calculatedRatio = HEIGHT / base.baseHeight;
            const calculatedWidth = WIDTH / calculatedRatio;
            return {
              height: base.baseHeight,
              width: calculatedWidth,
              transform: `scale(${calculatedRatio})`,
            };
          } else {
            const calculatedRatio = HEIGHT / base.baseHeight;
            const calculatedWidth = WIDTH / calculatedRatio;
            return {
              height: base.baseHeight,
              width: calculatedWidth,
              transform: `scale(${calculatedRatio})`,
            };
          }
        } else if (base.type === "WIDGET_STROKES") {
          return {
            height: base.height,
            width: base.width,
            transform: `scale(1)`,
          };
        } else {
          const calculatedRatio = HEIGHT / base.baseHeight;
          const calculatedWidth = WIDTH / calculatedRatio;
          return {
            height: base.baseHeight,
            width: calculatedWidth,
            transform: `scale(${calculatedRatio})`,
          };
        }
      }
    } else {
      if (side === "outside") {
        return { height: base.height, width: base.width };
      } else if (side === "inside") {
        return {
          height: base.height,
          width: base.width,
          transform: `scale(1)`,
        };
      }
    }
  };

  const handleClick = useCallback(
    (e: any) => {
      props.onSelect(e, props.data.id);
      setSideDrag(false);
    },
    [props.data.id, props.onSelect],
  );

  const removeClick = useCallback(
    (e: any) => {
      props.onRemove(e, props.data.id);
    },
    [props.data.id, props.onRemove],
  );

  const openOption = () => {
    setIsOpen(true);
  };
  const closeOption = () => {
    setIsOpen(false);
  };

  const cardHeaderToggle = (tab: string) => {
    if (cardHeaderTab !== tab) {
      setcardHeaderTab(tab);
    }
  };

  useEffect(() => {
    insetCode();
  }, [codeValue]);

  const insetCode = () => {
    const data = props.data.data;
    if (
      props.data.type === "WIDGET_QR_CODE" ||
      props.data.type === "WIDGET_EMBED" ||
      props.data.type === "WIDGET_VIDEO_TIMELINE"
    ) {
      data.codeStr = codeValue;
      onUpdate({ id: props.data.id, data: { ...data } });
    }
  };

  const QrTitleSwitch = (status: any) => {
    const DATA = props.data.data;
    DATA.titleSwitch = status;

    let update: any;
    if (status) {
      update = {
        id: props.data.id,
        baseHeight: 393,
        height: props.data.height + 78,
        minHeight: 328,
        data: DATA,
      };
      setMinSize({
        minWidth: 250,
        minHeight: 328,
      });
    } else {
      update = {
        id: props.data.id,
        baseHeight: 315,
        height: props.data.height - 78,
        minHeight: 250,
        data: DATA,
      };
      setMinSize({
        minWidth: 250,
        minHeight: 250,
      });
    }

    onUpdate(update);
    actionEnd(true);
  };

  const changeQRcodeTitle = (title: any) => {
    const DATA = props.data.data;
    DATA.title = title;
    const update: any = { id: props.data.id, data: DATA };
    onUpdate(update);
    actionEnd(true);
  };

  const insetValueToRandom = () => {
    const data = props.data.data;
    const newList: string[] = inputValue.split("\n");
    data.nameList = newList.filter((item: any) => item !== "");
    onUpdate({ id: props.data.id, data: { ...data } });
    cardHeaderToggle("Settings");

    if (recordThis) {
      let newList: any = inputValue.split("\n");
      newList = newList.filter((item: any) => item !== "");
      newList = newList.join("\n");
      dispatch(
        MemberCreateAction({
          user_data: newList,
        }),
      );
      setTimeout(() => {
        setRecordThis(false);
      }, 1000);
    }
  };

  const insetValueToGroup = () => {
    const data = props.data.data;
    const newList: string[] = inputValue.split("\n");
    data.nameList = newList.filter((item: any) => item !== "");
    onUpdate({
      id: props.data.id,
      baseHeight: 600,
      height: 600,
      width: 720,
      data: { ...data },
    });
    cardHeaderToggle("Settings");

    if (recordThis) {
      let newList: any = inputValue.split("\n");
      newList = newList.filter((item: any) => item !== "");
      newList = newList.join("\n");
      dispatch(
        MemberCreateAction({
          user_data: newList,
        }),
      );
      setTimeout(() => {
        setRecordThis(false);
      }, 1000);
    }
  };

  const handleChoice = (item: any) => {
    setInputValue(item.user_data);
  };

  const insetCardValue = () => {
    const data = props.data.data;
    const newList: string[] = cardValue.split("\n");
    data.title = cardTitle;
    data.cardList = newList.filter((item: any) => item !== "");
    data.action = "shuffle";
    data.start = true;
    const updataObj: any = {
      id: props.data.id,
      data: { ...data },
    };
    if (!props.data.data.start) {
      updataObj["baseHeight"] = 188;
      updataObj["height"] = 288;
      updataObj["width"] = 512;
    }
    onUpdate(updataObj);
    actionEnd(true);
    cardHeaderToggle("Settings");
    setIsCardOpen(true);

    if (recordThis) {
      let newList: any = cardValue.split("\n");
      newList = newList.filter((item: any) => item !== "");
      newList = newList.join("\n");
      dispatch(
        CardCreateAction({
          name: cardTitle,
          card_data: newList,
        }),
      );
      setTimeout(() => {
        setRecordThis(false);
      }, 1000);
    }
  };

  const handleCardChoice = (item: any) => {
    setCardTitle(item.name);
    setCardValue(item.card_data);
  };

  const removeRememberItem = (index: number) => {
    const data = props.data.data;
    const newList = [...props.data.data.remember];
    newList.splice(index, 1);
    data.remember = newList;
    onUpdate({ id: props.data.id, data: { ...data } });
  };

  const removeRemember = () => {
    const data = props.data.data;
    data.remember = [];
    setInsideSwitch(true);
    setTimeout(() => {
      setInsideSwitch(false);
    }, 1000);
    onUpdate({ id: props.data.id, data: { ...data } });
  };

  const handleRangeChange = (newValues: any) => {
    if (newValues[0] >= 2) {
      setGroups(newValues[0]);
      const data = props.data.data;
      data.groups = newValues[0];
      onUpdate({ id: props.data.id, data: { ...data } });
      actionEnd(true);
    }
  };

  const [selectedFile, setSelectedFile] = useState("");
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const files = e.target.files ? e.target.files : null;
    if (files) {
      setImageSchedule(files);
      setImageScheduleCount(files.length);
      setEditId(props.data.id);
      setFitToImage(true);
    }
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files ? e.dataTransfer.files : null;
    if (files) {
      setImageSchedule(files);
      setImageScheduleCount(files.length);
      setEditId(props.data.id);
      setFitToImage(true);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const imageRotate = (type: string) => {
    const data = props.data.data;
    if (type === "right") {
      ++data.rotate;
    } else {
      --data.rotate;
    }
    actionEnd(true);
    onUpdate({ id: props.data.id, data: { ...data } });
  };

  const selectedImage = (item: any) => {
    const data = props.data.data;
    data.imgId = item.id;
    data.path = item.path;
    const update: any = { id: props.data.id, data: data };
    onUpdate(update);
    actionEnd(true);
    props.callUpdateBoard();
  };

  const deleteImage = (item: any) => {
    let token = null;
    if (getAuthToken()) {
      token = getAuthToken();
    } else if (getTeacherAuthToken()) {
      token = getTeacherAuthToken();
    }
    const headers = new Headers();
    if (token) {
      headers.append("userToken", token);
    }
    fetch(
      `${process.env.REACT_APP_API_URL}/api/elements/deleteImages/${item.id}`,
      {
        method: "DELETE",
        headers: headers,
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.status != "SUCCESS") {
          throw data;
        } else {
          //
          dispatch(ImageListGetAction({ id: props.data.BoardId }));
        }
      })
      .catch(e => {
        console.log("error", e);

        dispatch(setError("圖片刪除失敗"));
      });
  };

  const deleteSwitch = () => {
    setShowDelete(!showDelete);
  };

  const onChangeTextType = (type: string) => {
    const data = props.data.data;
    data.type = type;
    const updateData: any = {
      id: props.data.id,
      data: { ...data },
    };
    if (type === "text") {
      popupRef.current.style.height = `400px`;
      updateData.height = 400;
      updateData.width = 650;
    } else if (type === "marquee") {
      popupRef.current.style.height = `48px`;
      updateData.height = 128;
      updateData.width = 650;
    }
    onUpdate(updateData);
    actionEnd(true);
  };

  const onChangeMarqueeFontSize = (fontSize: number) => {
    const data = props.data.data;
    data.marquee.fontSize = fontSize;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeScrollDirection = (direction: string) => {
    const data = props.data.data;
    data.marquee.direction = direction;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeMarqueeSpeed = (speed: number) => {
    const data = props.data.data;
    if (data.marquee) {
      data.marquee.speed = speed;
    }
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeCountDown = (countdown: number) => {
    const data = props.data.data;
    data.Countdown = countdown;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeEventNameFontSize = (fontSize: number) => {
    const data = props.data.data;
    data.eventNameFontSize = fontSize;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeFormat = (target: string) => {
    const data = props.data.data;
    if (target === "time12HourFormat") {
      data.time24HourFormat = false;
      data.time12HourFormat = true;
    } else if (target === "time24HourFormat") {
      data.time12HourFormat = false;
      data.time24HourFormat = true;
    }
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeWeekStart = (target: string) => {
    const data = props.data.data;
    if (target === "Monday") {
      data.Monday = true;
      data.Sunday = false;
    } else if (target === "Sunday") {
      data.Monday = false;
      data.Sunday = true;
    }
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeTimeType = (target: string) => {
    const data = props.data.data;
    if (target === "Lap") {
      data.Lap = true;
      data.Split = false;
    } else if (target === "Split") {
      data.Lap = false;
      data.Split = true;
    }
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onTimetableTitleSwitch = (e: any) => {
    const data = props.data.data;
    let minHeight;
    if (e.target.checked) {
      minHeight = data.timeTable.length * 40 + 10 + 22;
    } else {
      minHeight = data.timeTable.length * 40 + 10;
    }
    data.listTitleShow = e.target.checked;
    onUpdate({ id: props.data.id, minHeight: minHeight, data: { ...data } });
    actionEnd(true);
  };

  const onTimetableTitleChange = (e: any) => {
    const data = props.data.data;
    data.listTitle = e.target.value;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeTimetableType = (e: any) => {
    const data = props.data.data;
    data.listType = e.target.value;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeTimetableFirst = (e: any, type: string) => {
    const data = props.data.data;
    data.firstTime[type] = e.target.value;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const addActiveItem = (type: string) => {
    const data = props.data.data;
    const newActive = {
      id: random(12),
      type: type,
      title: "",
      checked: false,
      duration: type === "active" ? 40 : 10,
    };
    data.timeTable.push(newActive);
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeTimeTableTitle = (e: any, index: number) => {
    const data = props.data.data;
    const newTimeArray = [...data.timeTable];
    newTimeArray[index].title = e.target.value;
    data.timeTable = newTimeArray;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const deleteTimeItem = (index: number) => {
    const data = props.data.data;
    const newTimeArray = [...data.timeTable];
    newTimeArray.splice(index, 1);
    data.timeTable = newTimeArray;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onChangeDuration = (e: any, index: number) => {
    const data = props.data.data;
    const newTimeArray = [...data.timeTable];
    newTimeArray[index].duration = e.target.value;
    data.timeTable = newTimeArray;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  const onClickChangeDuration = (e: any, type: string, index: number) => {
    const data = props.data.data;
    const newTimeArray = [...data.timeTable];
    let newDuration;
    if (type === "minus" && newTimeArray[index].duration > 0) {
      newDuration = newTimeArray[index].duration - 5;
      newTimeArray[index].duration = newDuration;
      data.timeTable = newTimeArray;
      onUpdate({ id: props.data.id, data: { ...data } });
      actionEnd(true);
    } else if (type === "plus") {
      newDuration = newTimeArray[index].duration + 5;
      newTimeArray[index].duration = newDuration;
      data.timeTable = newTimeArray;
      onUpdate({ id: props.data.id, data: { ...data } });
      actionEnd(true);
    }
  };

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;
    const data = props.data.data;
    const updatedItems = [...data.timeTable];
    const [reorderedItem] = updatedItems.splice(result.source.index, 1);
    updatedItems.splice(result.destination.index, 0, reorderedItem);
    const reorderedItemsWithQueue = updatedItems.map(
      (item: any, index: number) => ({
        ...item,
        queue: index,
      }),
    );
    data.timeTable = reorderedItemsWithQueue;
    onUpdate({ id: props.data.id, data: { ...data } });
    actionEnd(true);
  };

  //

  const [Horizontal, setHorizontal] = useState(1);
  const [Vertical, setVertical] = useState(1);
  const videoRotate = (type: string) => {
    if (type === "horizontal") {
      if (Horizontal < 0) {
        setHorizontal(1);
      } else if (Horizontal > 0) {
        setHorizontal(-1);
      }
    } else if (type === "vertical") {
      if (Vertical < 0) {
        setVertical(1);
      } else if (Vertical > 0) {
        setVertical(-1);
      }
    }
  };

  const embedSize = (size: any) => {
    popupRef.current.style.width = `${size.width}px`;
    popupRef.current.style.height = `${size.height}px`;
    setSize({ width: size.width, height: size.height });
  };

  const changeEmbedCode = (e: any) => {
    const DATA = props.data.data;
    DATA.codeStr = e.target.value;
    onUpdate({ id: props.data.id, data: { codeStr: e.target.value } });
    actionEnd(true);
  };

  const [showControl, setShowControl] = useState<boolean>(false);
  const toggleControl = () => {
    setShowControl(!showControl);
  };

  const [showEditorTool, setShowEditorTool] = useState<boolean>(true);
  const toggleEditorTool = () => {
    setShowEditorTool(!showEditorTool);
  };

  const [LinkOpen, setLinkOpen] = useState<string>("1");
  const openThis = (id: string) => {
    if (props.data.data?.linkList) {
      for (let i = 0; i < props.data.data.linkList.length; i++) {
        const element = props.data.data?.linkList[i];
        element.isOpen = false;
      }
      props.data.data.linkList[Number(id) - 1].isOpen = true;
      setLinkOpen(id);
    }
  };
  const changeLinkTitle = (title: any, index: number) => {
    const DATA = props.data.data;
    DATA.linkList[index].title = title;
    const listTitle = title !== "" ? title : DATA.linkList[index].link;
    const update: any = { id: props.data.id, data: DATA };
    if (listTitle !== "") {
      update["listTitle"] = listTitle;
    }
    onUpdate(update);
    actionEnd(true);
  };
  const getLinkPreviewData = async (link: any, index: number) => {
    const BoardId = getUrlParameter("board");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/elements/url/${BoardId}`;
    const DATA = props.data.data;
    DATA.linkList[index].link = link;
    const listTitle = link;
    const update: any = { id: props.data.id, data: DATA };
    if (listTitle !== "") {
      update["listTitle"] = listTitle;
    }
    onUpdate(update);
    actionEnd(true);

    fetch(apiUrl, {
      method: "POST",
      headers: {
        userToken: `${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        url: link,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.status != "SUCCESS") {
          DATA.linkList[index].title = "";
          DATA.linkList[index].icon = "";
          onUpdate({ id: props.data.id, data: { ...DATA } });
          actionEnd(true);
        } else {
          DATA.linkList[index].title = data.data.title;
          DATA.linkList[index].icon = data.data.icon;
          onUpdate({ id: props.data.id, data: { ...DATA } });
          actionEnd(true);
        }
      })
      .catch(e => {
        console.log("error", e);
        DATA.linkList[index].title = "";
        DATA.linkList[index].icon = "";
        onUpdate({ id: props.data.id, data: { ...DATA } });
        actionEnd(true);

        dispatch(setError("連結資訊取得失敗"));
      });
  };

  const resizePosition = ({
    box,
    top,
    left,
    bottomExtra = 0,
  }: {
    box: any;
    top: number;
    left: number;
    bottomExtra?: number;
  }) => {
    const ToolHeight =
      (toolRef.current ? toolRef.current.getBoundingClientRect().height : 0) /
      scale /
      2;
    const ToolWidth =
      (toolRef.current ? toolRef.current.getBoundingClientRect().width : 0) /
      scale /
      2;
    // const topBorder = 32;
    const topBorder = ToolHeight + 12;
    const leftBorder = ToolWidth + 16;
    const rightBorder = 1920 - (ToolWidth + 16);
    // const bottomBorder = 1080 - 40;
    const bottomBorder = 1080 - (ToolHeight + 20);
    return {
      top: `calc(${
        top < topBorder
          ? top + box.height + 78 + bottomExtra < topBorder
            ? topBorder
            : top + box.height + 78 + bottomExtra
          : top > bottomBorder
          ? bottomBorder
          : top
      }px - 1rem)`,
      left:
        left < leftBorder
          ? leftBorder
          : left > rightBorder
          ? rightBorder
          : left,
    };
  };

  const BASE_URL = `${process.env.REACT_APP_API_URL}/elements/image/`;

  const themeList: any[] = [
    { name: "theme1" },
    { name: "theme2" },
    { name: "theme3" },
  ];

  const toggelsetErrorAlert = () => {
    setErrorAlert(!errorAlert);
  };

  const writingType = (type: string) => {
    setWriting(type);
  };

  const toggelshowFontSettings = () => {
    setShowFontSettings(!showFontSettings);
  };

  useEffect(() => {
    setWorksData(works);
  }, [works]);

  const handleListChange = (event: any) => {
    const listId = event.target.value;
    const list = worksData.find((item: any) => {
      return item.id === listId;
    });
    setSelectedList(list);
    setSelectedZone(null);
  };

  const handleZoneChange = (event: any) => {
    const zoneId = event.target.value;
    const zone = selectedList.zone_list.find((item: any) => {
      return item.id === zoneId;
    });
    setSelectedZone(zone);
  };

  const innerData = (item: any) => {
    const DATA = props.data.data;
    DATA.workObj = JSON.stringify(item);
    onUpdate({
      id: props.data.id,
      baseHeight: 450,
      height: 450,
      width: 540,
      data: { ...DATA },
    });
    actionEnd(true);
  };

  useEffect(() => {
    if (destroyThis) {
      setTimeout(() => {
        removeClick("");
        closeOption();
      }, 0);
    }
  }, [destroyThis]);

  useEffect(() => {
    if (sideDrag) {
      handleClick("");
    }
  }, [sideDrag]);

  return (
    <>
      {nowPage || !hideCheck(props.data.type) ? (
        <React.Fragment>
          {/*  */}
          <React.Fragment>
            {props.data.type !== "WIDGET_WORKS" ? (
              <div
                ref={el => {
                  popupRef.current = el;
                  if (localRef) localRef(el);
                }}
                id={props.data.id}
                className={`componentItem ${
                  props.data.type === "WIDGET_HYPERLINK" ? "componentCore " : ""
                } ${props.data.data?.titleSwitch ? "title-show" : ""} ${
                  props.data.spotlight ? "showItem" : ""
                } ${
                  props.data.type !== "WIDGET_GROUP_MAKER"
                    ? "draggable-resizable"
                    : ""
                } this-theme relative transition-[opacity] opacity-100 ${
                  !username && props.data.type !== "WIDGET_GROUP_MAKER"
                    ? "cursor-move"
                    : "nonUser"
                } ${!selfDisplay ? "displayOff" : ""} ${props.data.className}${
                  !props.data.selected ? " unSelected" : ""
                } ${Theme}`}
                style={{
                  ...StyleSet(props.data),
                  ...PositionSet(props.data, position),
                  zIndex: props.data.zIndex,
                  transform:
                    componentCheck(props.data.type) ||
                    (props.data.type === "WIDGET_MIND_MAP" && mindMapEdit)
                      ? `scale(1)`
                      : "",
                  filter:
                    props.data.type !== "WIDGET_STROKES"
                      ? "drop-shadow(0px 0px 2px #00000038)"
                      : "unset",
                  overflow:
                    props.data.type === "WIDGET_IMAGE" ? "unset" : "hidden",
                  pointerEvents: holdThisBox ? "none" : "auto",
                }}
                data-interaction-ignore-drag={
                  props.data.type !== "WIDGET_DRAW" ? false : true
                }
                data-interaction-target-type={true}
                onPointerDown={(e: any) => {
                  if (
                    (toolSwitch === "cursor" && !groupSelect) ||
                    (toolSwitch === "draw" && jobType !== "eraser")
                  ) {
                    if (!isCountdownOpen) {
                      dragMouseDown(
                        e,
                        setPosition,
                        false,
                        popupRef,
                        onUpdate,
                        scale,
                        props.data.id,
                        props.data,
                        username,
                        actionEnd,
                        props.data.type !== "WIDGET_TEXT" &&
                          props.data.type !== "WIDGET_GROUP_MAKER" &&
                          props.data.type !== "WIDGET_EMBED",
                        {
                          onSelect: props.onSelect,
                          setSideDrag: setSideDrag,
                        },
                      );
                    }
                    if (props.data.type !== "WIDGET_CARD") {
                      handleDoubleClick(e);
                    }
                  } else {
                    if (props.data.type === "WIDGET_STROKES") {
                      props.onRemove(e, props.data.id);
                    }
                  }
                }}
                onPointerUp={(e: any) => {
                  if (props.data.onLock) {
                    handleClick(e);
                  }
                  if (
                    (toolSwitch === "cursor" && !groupSelect) ||
                    (toolSwitch === "draw" && jobType !== "eraser")
                  ) {
                    if (jobType === "grab") {
                      setCursorItem(props.data);
                    }
                    if (
                      props.data.type === "WIDGET_EMBED" ||
                      props.data.type === "WIDGET_TEXT" ||
                      props.data.type === "WIDGET_GROUP_MAKER"
                    ) {
                      handleClick(e);
                    }
                  }
                }}
                data-target-type={props.data.type}
                data-target-id={props.data.id}
              >
                {props.data.studentName ? (
                  <div className="nameCard">{props.data.studentName}</div>
                ) : null}
                {/*  */}
                {props.data.type !== "WIDGET_GROUP_MAKER" &&
                props.data.type !== "WIDGET_TEXT" &&
                props.data.type !== "WIDGET_READ" &&
                props.data.type !== "WIDGET_DRAW" &&
                props.data.type !== "WIDGET_WORKS" &&
                props.data.type !== "WIDGET_CARD" ? (
                  <div
                    className="absolute top-0 start-0 origin-left-top"
                    style={boxSizeSet(popupRef, props.data, "outside")}
                  >
                    <div
                      ref={insideRef}
                      className="absolute top-0 start-0 origin-left-top"
                      style={boxSizeSet(popupRef, props.data, "inside")}
                    >
                      <div
                        className="absolute inset-0 z-0"
                        style={{
                          ...StyleSet(props.data),
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <div
                          className="absolute h-100 w-100 top-0 start-0"
                          style={{ zIndex: 1 }}
                        >
                          <div className="relative flex h-full flex-col items-center justify-center">
                            {/*  */}
                            {props.data.type === "WIDGET_RANDOM_NAME" ? (
                              <RandomNameModule
                                config={props.data}
                                insideRef={insideRef}
                                insideSwitch={insideSwitch}
                                openOption={openOption}
                                onUpdate={onUpdate}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_QR_CODE" ? (
                              <QRcodeModule
                                config={props.data}
                                CodeValue={setCodeValue}
                                SetPending={setSetPending}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                                setCanCopy={setCanCopy}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_IMAGE" ? (
                              <ImageModule
                                config={props.data}
                                imageSrc={props.data.data.path}
                                openOption={openOption}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                                fitToImage={fitToImage}
                                setFitToImage={setFitToImage}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_TIMER" ? (
                              <TimerModule
                                config={{ data: props.data }}
                                scale={scale}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_CLOCK" ? (
                              <ClockModule
                                config={{
                                  data: props.data,
                                  size: boxSizeSet(
                                    popupRef,
                                    props.data,
                                    "inside",
                                  ),
                                }}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_WEBCAM" ? (
                              <WebcamModule
                                horizontal={Horizontal}
                                vertical={Vertical}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_EMBED" ? (
                              <EmbedModule
                                config={props.data}
                                CodeValue={setCodeValue}
                                SetPending={setSetPending}
                                onUpdateSize={embedSize}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                                setCanCopy={setCanCopy}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_VIDEO_TIMELINE" ? (
                              <VideoTimelineModule
                                config={props.data}
                                nowPage={nowPage}
                                CodeValue={setCodeValue}
                                SetPending={setSetPending}
                                showControl={showControl}
                                setShowControl={setShowControl}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                                setCanCopy={setCanCopy}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_CALENDAR" ? (
                              <CalendarModule
                                config={props.data}
                                scale={scale}
                                insideRef={insideRef}
                                onUpdate={onUpdate}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_TIMETABLE" ? (
                              <TimeTableModule
                                config={props.data}
                                boxRef={popupRef}
                                openOption={openOption}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_STOPWATCH" ? (
                              <StopwatchModule
                                config={props.data}
                                boxRef={popupRef}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_EVENT_COUNTDOWN" ? (
                              <EventCountdownModule
                                config={props.data}
                                scale={scale}
                                insideRef={insideRef}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                                open={isCountdownOpen}
                                setIsOpen={setIsCountdownOpen}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_HYPERLINK" ? (
                              <HyperLinkModule
                                config={props.data}
                                boxRef={popupRef}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                                setCanCopy={setCanCopy}
                              />
                            ) : null}
                            {props.data.type === "WIDGET_STROKES" ? (
                              <DrawStrokeModule config={props.data} />
                            ) : null}
                            {props.data.type === "WIDGET_MIND_MAP" ? (
                              <MindMapModule
                                ref={iframeComponentRef}
                                config={props.data}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                                setMinSize={setMinSize}
                                mindMapEdit={mindMapEdit}
                                setMindMapEdit={setMindMapEdit}
                                userPermission={userPermission}
                                fitToImage={fitToImage}
                                setFitToImage={setFitToImage}
                                cooperate={cooperate}
                              />
                            ) : null}
                            {/*  */}
                          </div>
                        </div>
                        {!username &&
                        !props.data.selected &&
                        moveCheck(props.data.type) ? (
                          <div
                            className="absolute h-100 w-100 top-0 start-0"
                            style={{ zIndex: 2 }}
                          ></div>
                        ) : null}
                        {username &&
                        !props.data.selected &&
                        moveCheck(props.data.type) &&
                        props.data.type !== "WIDGET_MIND_MAP" ? (
                          <div
                            className="absolute h-100 w-100 top-0 start-0"
                            style={{ zIndex: 2 }}
                          ></div>
                        ) : null}
                        {/* {username && props.data.type === "WIDGET_MIND_MAP" && !userPermission ? (
                          <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
                        ) : null} */}
                      </div>
                    </div>
                  </div>
                ) : null}

                {props.data.type === "WIDGET_CARD" ? (
                  <div
                    className="absolute top-0 start-0 origin-left-top"
                    style={boxSizeSet(popupRef, props.data, "outside")}
                  >
                    <CardModule
                      config={props.data}
                      zoom={scale}
                      insideRef={insideRef}
                      onUpdate={onUpdate}
                      actionEnd={actionEnd}
                      save={isCardOpen}
                      setIsOpen={openOption}
                      socketRequest={socketRequest}
                      boardInfoId={boardInfoId}
                      itemSpotlight={itemSpotlight}
                      inside={boxSizeSet(popupRef, props.data, "inside")}
                      popupRef={popupRef}
                      hoverCard={hoverCard}
                      nowPage={nowPage}
                    />
                  </div>
                ) : null}
                {props.data.type === "WIDGET_GROUP_MAKER" ? (
                  <div
                    className="absolute top-0 start-0 origin-left-top"
                    style={boxSizeSet(popupRef, props.data, "outside")}
                  >
                    <GroupMakerModule
                      config={props.data}
                      insideRef={insideRef}
                      insideSwitch={insideSwitch}
                      openOption={openOption}
                      onUpdate={onUpdate}
                      actionEnd={actionEnd}
                      inside={boxSizeSet(popupRef, props.data, "inside")}
                    />
                  </div>
                ) : null}
                {props.data.type === "WIDGET_TEXT" ? (
                  <div
                    className="absolute top-0 start-0 origin-left-top"
                    style={boxSizeSet(popupRef, props.data, "outside")}
                  >
                    <TextModule
                      config={{
                        data: props.data,
                        ...size,
                        ...position,
                        selected: props.data.selected,
                      }}
                      scale={scale}
                      showEditorTool={showEditorTool}
                      onUpdate={onUpdate}
                      actionEnd={actionEnd}
                      userPermission={userPermission}
                      handleSelectClick={handleClick}
                      destroyThis={destroyThis}
                      setCanCopy={setCanCopy}
                    />
                  </div>
                ) : null}
                {props.data.type === "WIDGET_READ" ? (
                  <div
                    className="absolute top-0 start-0 origin-left-top"
                    style={boxSizeSet(popupRef, props.data, "outside")}
                  >
                    <ReadModule
                      config={{
                        data: props.data,
                        ...size,
                        ...position,
                        writingType: Writing,
                        showFontSetting: showFontSettings,
                        selected: props.data.selected,
                        FontSize: FontSize,
                        FontSpace: FontSpace,
                      }}
                      scale={scale}
                      onSelect={props.onSelect}
                      showEditorTool={showEditorTool}
                      onUpdate={onUpdate}
                      actionEnd={actionEnd}
                      toSpotlight={itemSpotlight}
                      setCanCopy={setCanCopy}
                    />
                  </div>
                ) : null}
              </div>
            ) : (
              <div
                ref={el => {
                  popupRef.current = el;
                  if (localRef) localRef(el);
                }}
                id={props.data.id}
                className={`componentItem draggable-resizable this-theme relative transition-[opacity] opacity-100 ${
                  !username ? "cursor-move" : "nonUser"
                } ${!selfDisplay ? "displayOff" : ""} ${
                  props.data.spotlight ? "showItem" : ""
                } ${props.data.className}${
                  !props.data.selected ? " unSelected" : ""
                } ${Theme}`}
                style={{
                  ...StyleSet(props.data),
                  ...PositionSet(props.data, position),
                  zIndex: props.data.zIndex,
                  transform: componentCheck(props.data.type)
                    ? `scale(${scale})`
                    : "",
                  filter: "drop-shadow(0px 0px 2px #00000038)",
                  pointerEvents: holdThisBox ? "none" : "auto",
                }}
                onPointerDown={(e: any) => {
                  if (
                    (toolSwitch === "cursor" && !groupSelect) ||
                    (toolSwitch === "draw" && jobType !== "eraser")
                  ) {
                    handleDoubleClick(e);
                  } else {
                    if (props.data.type === "WIDGET_STROKES") {
                      props.onRemove(e, props.data.id);
                    }
                  }
                }}
                onPointerUp={(e: any) => {
                  if (
                    (toolSwitch === "cursor" && !groupSelect) ||
                    (toolSwitch === "draw" && jobType !== "eraser")
                  ) {
                    handleClick(e);
                  }
                }}
                data-target-type={props.data.type}
                data-target-id={props.data.id}
              >
                {props.data.studentName ? (
                  <div className="nameCard">{props.data.studentName}</div>
                ) : null}
                {/*  */}
                <div
                  className="absolute top-0 start-0 origin-left-top"
                  style={boxSizeSet(popupRef, props.data, "outside")}
                >
                  <WorksModule
                    config={props.data}
                    insideRef={insideRef}
                    insideSwitch={insideSwitch}
                    openOption={openOption}
                    onUpdate={onUpdate}
                    actionEnd={actionEnd}
                    inside={boxSizeSet(popupRef, props.data, "inside")}
                  />
                </div>
                {!props.data.selected && moveCheck(props.data.type) ? (
                  <div
                    className="absolute h-100 w-100 top-0 start-0"
                    style={{ zIndex: 2 }}
                    onPointerDown={(e: any) => {
                      handleClick(e);
                    }}
                  ></div>
                ) : null}
              </div>
            )}
          </React.Fragment>
          {/*  */}
          {true ? (
            <React.Fragment>
              {!username ||
              (username && props.data.studentName === username) ? (
                <div
                  ref={toolRef}
                  className="itemToolbar absolute"
                  style={{
                    ...resizePosition({
                      box: props.data,
                      top: position.y - 43,
                      left: position.x + props.data.width / 2,
                      bottomExtra:
                        props.data.type === "WIDGET_VIDEO_TIMELINE" &&
                        showControl
                          ? 65 * (props.data.height / props.data.baseHeight)
                          : 0,
                    }),
                    zIndex: 1000107,
                    transform: `translateX(-50%) scale(${1 / scale})`,
                    visibility:
                      props.data.selected &&
                      selfDisplay &&
                      screenData.screenWidth > 1 &&
                      toolSwitch === "cursor"
                        ? "visible"
                        : "hidden",
                  }}
                  data-interaction-ignore-drag={
                    props.data.type !== "WIDGET_DRAW" ? false : true
                  }
                  data-interaction-target-type={true}
                  data-target-type="toolbar"
                >
                  <div className="ts-toolBar">
                    <div className="ts-item-number">{props.data.idx + 1}</div>
                    {moveCheck(props.data.type) ? (
                      <React.Fragment>
                        <div
                          className="ts-btn ts-btnGroup ts-move"
                          onPointerDown={(e: any) => {
                            dragMouseDown(
                              e,
                              setPosition,
                              setHoldThisBox,
                              popupRef,
                              onUpdate,
                              scale,
                              props.data.id,
                              props.data,
                              username,
                              actionEnd,
                              true,
                            );
                            handleClick(e);
                          }}
                          data-interaction-target-type={true}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <i className="mdi mdi-cursor-move fs-20"></i>
                          </div>
                        </div>
                        <div className="ts-gap ts-btnGroup"></div>
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_IMAGE" ? (
                      <React.Fragment>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            imageRotate("left");
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <img src={turnLeft} alt="" />
                          </div>
                        </div>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            imageRotate("right");
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <img src={turnRight} alt="" />
                          </div>
                        </div>
                        <div className="ts-gap ts-btnGroup"></div>
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_WEBCAM" ? (
                      <React.Fragment>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            videoRotate("horizontal");
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <i className="mdi mdi-select-compare fs-24"></i>
                          </div>
                        </div>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            videoRotate("vertical");
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <i className="mdi mdi-select-compare deg-90 fs-24"></i>
                          </div>
                        </div>
                        <div className="ts-gap ts-btnGroup"></div>
                      </React.Fragment>
                    ) : null}
                    <div
                      className={`text-tool-bar ${
                        props.data.selected &&
                        selfDisplay &&
                        screenData.screenWidth > 1 &&
                        toolSwitch === "cursor" &&
                        props.data.type === "WIDGET_TEXT" &&
                        ((!username && !props.data.studentName) ||
                          (username && username === props.data.studentName)) &&
                        (!props.data.data.type ||
                          props.data.data.type === "text")
                          ? "textBar-show"
                          : ""
                      }`}
                    >
                      <div
                        id={`external-toolbar_${props.data.id}`}
                        style={{
                          display: "flex",
                          padding: 0,
                          alignItems: "center",
                        }}
                      >
                        <select className="ql-font" defaultValue={"Arial"}>
                          <option value="注音芫荽">注音芫荽</option>
                          <option value="Arial">Arial</option>
                          <option value="Courier New">Courier New</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Impact">Impact</option>
                          <option value="Lucida Console">Lucida Console</option>
                          <option value="Tahoma">Tahoma</option>
                          <option value="Times New Roman">
                            Times New Roman
                          </option>
                          <option value="Trebuchet MS">Trebuchet MS</option>
                          <option value="Verdana">Verdana</option>
                        </select>
                        <select className="ql-size" defaultValue={"14px"}>
                          <option value="14px">14</option>
                          <option value="18px">18</option>
                          <option value="22px">22</option>
                          <option value="28px">28</option>
                          <option value="36px">36</option>
                          <option value="48px">48</option>
                          <option value="64px">64</option>
                          <option value="96px">96</option>
                          <option value="120px">120</option>
                        </select>
                        <button className="ql-bold"></button>
                        <button className="ql-italic"></button>
                        <button className="ql-underline"></button>
                        <select className="ql-color"></select>
                        <select className="ql-background"></select>
                        <button className="ql-script" value="sub"></button>
                        <button className="ql-script" value="super"></button>

                        <button className="ql-list" value="ordered"></button>
                        <button className="ql-list" value="bullet"></button>
                        <select className="ql-align">
                          <option></option>
                          <option value="center"></option>
                          <option value="right"></option>
                          <option value="justify"></option>
                        </select>
                        <button className="ql-formula"></button>
                      </div>
                      <div className="ts-gap ts-btnGroup"></div>
                    </div>
                    {props.data.type === "WIDGET_READ" &&
                    !username &&
                    !props.data.studentName ? (
                      <React.Fragment>
                        <div
                          className="ts-btn ts-btnGroup ts-select"
                          // onPointerDown={(e: any) => {writingType("Horizontal")}}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <select
                              style={{ "--scalesize": 1 / scale }}
                              onChange={(e: any) => {
                                setFontSize(e.target.value);
                              }}
                              value={FontSize}
                            >
                              <option value="11">1 (8pt)</option>
                              <option value="13">2 (10pt)</option>
                              <option value="16">3 (12pt)</option>
                              <option value="19">4 (14pt)</option>
                              <option value="24">5 (18pt)</option>
                              <option value="32">6 (24pt)</option>
                              <option value="48">7 (36pt)</option>
                              <option value="64">8 (48pt)</option>
                              <option value="80">9 (60pt)</option>
                              <option value="96">10 (72pt)</option>
                              <option value="112">11 (84pt)</option>
                              <option value="128">12 (96pt)</option>
                              <option value="160">13 (120pt)</option>
                            </select>
                          </div>
                        </div>
                        <div
                          className="ts-btn ts-btnGroup ts-input"
                          // onPointerDown={(e: any) => {writingType("Horizontal")}}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <input
                              type="number"
                              onChange={(e: any) => {
                                setFontSpace(e.target.value);
                              }}
                              value={FontSpace}
                            />
                          </div>
                        </div>
                        <div className="ts-gap ts-btnGroup"></div>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            writingType("Horizontal");
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <i className="mdi mdi-align-horizontal-left fs-20"></i>
                          </div>
                        </div>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            writingType("Vertical");
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <i className="mdi mdi-align-vertical-top fs-20"></i>
                          </div>
                        </div>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            toggelshowFontSettings();
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <i className="mdi mdi-format-size fs-20"></i>
                          </div>
                        </div>
                        <div className="ts-gap ts-btnGroup"></div>
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_VIDEO_TIMELINE" &&
                    !props.data.data.isStream ? (
                      <React.Fragment>
                        <div
                          className="ts-btn ts-btnGroup"
                          onPointerDown={(e: any) => {
                            toggleControl();
                          }}
                        >
                          <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                            <i className="mdi mdi-ray-start-end fs-24"></i>
                          </div>
                        </div>
                        <div className="ts-gap ts-btnGroup"></div>
                      </React.Fragment>
                    ) : null}
                    {!username && props.data.onLock ? (
                      <>
                        {!username ? (
                          <div
                            className="ts-btn ts-btnGroup"
                            onPointerDown={() =>
                              onLock(props.data.id, props.data.onLock)
                            }
                          >
                            <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                              <img
                                src={lock}
                                alt=""
                                style={{ height: "auto", width: "16px" }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="ts-btn ts-btnGroup">
                            <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                              <img
                                src={lock}
                                alt=""
                                style={{ height: "auto", width: "16px" }}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    ) : null}
                    <div
                      className={`ts-btn ts-btnGroup ${
                        props.data.onLock ? "itemLock" : ""
                      }`}
                      onPointerDown={(e: any) => {
                        setDestroyThis(true);
                      }}
                    >
                      <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                        <img src={lightDelete} alt="" />
                      </div>
                    </div>
                    {(!username &&
                      !props.data.studentName &&
                      props.data.type !== "WIDGET_STROKES") ||
                    (username &&
                      username === props.data.studentName &&
                      props.data.type !== "WIDGET_STROKES") ? (
                      <div
                        className="ts-btn ts-btnGroup"
                        onPointerDown={(e: any) => {
                          openOption();
                        }}
                      >
                        <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                          <img src={setting} alt="" />
                        </div>
                      </div>
                    ) : null}
                    {!username ? (
                      <UncontrolledDropdown className="ts-btn ts-btnGroup">
                        <DropdownToggle
                          tag="button"
                          className=""
                          id="top-tool-dropdown"
                        >
                          <img src={dots} alt="" />
                        </DropdownToggle>
                        <Portal visible={nowPage}>
                          <DropdownMenu end={true} style={{ zIndex: 10000 }}>
                            <div className="ts-tool-group">
                              <div className="ts-tool-items">
                                <DropdownItem
                                  onPointerDown={() => copyItem(props.data)}
                                >
                                  <img
                                    src={item_copy}
                                    alt=""
                                    style={{ width: "18px" }}
                                  />
                                  <div>複製</div>
                                </DropdownItem>
                                {props.data.type !== "WIDGET_STROKES" ? (
                                  <DropdownItem
                                    onPointerDown={() => itemSpotlight()}
                                  >
                                    <i
                                      className="mdi mdi-spotlight-beam fs-20"
                                      style={{ transform: "rotateZ(180deg)" }}
                                    ></i>
                                    <div>放大</div>
                                  </DropdownItem>
                                ) : null}
                                {!username ? (
                                  <DropdownItem
                                    onPointerDown={() =>
                                      onLock(props.data.id, props.data.onLock)
                                    }
                                  >
                                    <img
                                      src={lock}
                                      alt=""
                                      style={{ width: "18px" }}
                                    />
                                    <div>
                                      {props.data.onLock ? "解鎖" : "固定位置"}
                                    </div>
                                  </DropdownItem>
                                ) : null}
                                <DropdownItem
                                  className={`${
                                    props.data.onLock ? "itemLock" : ""
                                  }`}
                                  onPointerDown={() =>
                                    onUpDown(props.data.id, itemIndex, "up")
                                  }
                                >
                                  <img
                                    src={toTop}
                                    alt=""
                                    style={{ width: "18px" }}
                                  />
                                  <div>移到最前面</div>
                                </DropdownItem>
                                <DropdownItem
                                  className={`${
                                    props.data.onLock ? "itemLock" : ""
                                  }`}
                                  onPointerDown={() =>
                                    onUpDown(props.data.id, itemIndex, "down")
                                  }
                                >
                                  <img
                                    src={toBottom}
                                    alt=""
                                    style={{ width: "18px" }}
                                  />
                                  <div>移到最後面</div>
                                </DropdownItem>
                              </div>
                            </div>
                          </DropdownMenu>
                        </Portal>
                      </UncontrolledDropdown>
                    ) : null}
                  </div>
                </div>
              ) : null}
              {!username ||
              (username && props.data.studentName === username) ? (
                <div
                  className={`resize-handle absolute events-none origin-left-top ${
                    props.data.onLock ? "boxLock" : ""
                  }`}
                  style={{
                    ...PositionSet(props.data, position),
                    ...resizeStyleSet(props.data),
                    zIndex: 1000106,
                    // display: props.data.selected && selfDisplay && screenData.screenWidth > 1 && toolSwitch === "cursor"? "block" : "none"

                    opacity:
                      sideDrag ||
                      (props.data.selected &&
                        selfDisplay &&
                        screenData.screenWidth > 1)
                        ? 1
                        : 0,
                  }}
                  data-target-type="box"
                >
                  {!props.data.onLock ? (
                    <>
                      <div
                        data-side="top"
                        className={`${sideWidget ? "sideBtn" : ""}`}
                        data-interaction-target-type={true}
                      >
                        <div
                          className="side-resize-btn"
                          onPointerDown={e =>
                            resizeMouseDown(
                              e,
                              "top",
                              sideWidget,
                              minSize,
                              setSize,
                              setPosition,
                              setHoldThisBox,
                              popupRef,
                              onUpdate,
                              scale,
                              props.data.id,
                              props.data,
                              username,
                              actionEnd,
                            )
                          }
                          data-interaction-target-type="widget"
                          data-interaction-ignore-drag="false"
                          style={{
                            display:
                              sideDrag ||
                              (props.data.selected &&
                                selfDisplay &&
                                screenData.screenWidth > 1 &&
                                toolSwitch === "cursor")
                                ? "block"
                                : "none",
                          }}
                        ></div>
                        <div
                          className="side-resize-bar"
                          data-interaction-target-type={true}
                          onPointerDown={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              dragMouseDown(
                                e,
                                setPosition,
                                setHoldThisBox,
                                popupRef,
                                onUpdate,
                                scale,
                                props.data.id,
                                props.data,
                                username,
                                actionEnd,
                                true,
                              );
                              setSideDrag(true);
                            }
                          }}
                          onPointerUp={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              handleClick(e);
                            }
                          }}
                        ></div>
                      </div>
                      <div
                        data-side="right"
                        className={`${
                          sideWidget ||
                          sideWidget2 ||
                          (props.data.type === "WIDGET_MIND_MAP" &&
                            props.data.data.action === "edit")
                            ? "sideBtn"
                            : ""
                        }`}
                        data-interaction-target-type={true}
                      >
                        <div
                          className="side-resize-btn"
                          data-test={
                            props.data.type !== "WIDGET_HYPERLINK" &&
                            props.data.type !== "WIDGET_TIMETABLE" &&
                            props.data.type !== "WIDGET_MIND_MAP"
                              ? sideWidget
                              : sideWidget2 ||
                                (props.data.type === "WIDGET_MIND_MAP" &&
                                  props.data.data.action === "edit")
                          }
                          onPointerDown={e =>
                            resizeMouseDown(
                              e,
                              "right",
                              props.data.type !== "WIDGET_HYPERLINK" &&
                                props.data.type !== "WIDGET_TIMETABLE" &&
                                props.data.type !== "WIDGET_MIND_MAP"
                                ? sideWidget
                                : sideWidget2 ||
                                    (props.data.type === "WIDGET_MIND_MAP" &&
                                      props.data.data.action === "edit"),
                              minSize,
                              setSize,
                              setPosition,
                              setHoldThisBox,
                              popupRef,
                              onUpdate,
                              scale,
                              props.data.id,
                              props.data,
                              username,
                              actionEnd,
                            )
                          }
                          data-interaction-target-type="widget"
                          data-interaction-ignore-drag="false"
                          style={{
                            display:
                              sideDrag ||
                              (props.data.selected &&
                                selfDisplay &&
                                screenData.screenWidth > 1 &&
                                toolSwitch === "cursor")
                                ? "block"
                                : "none",
                          }}
                        ></div>
                        <div
                          className="side-resize-bar"
                          data-interaction-target-type={true}
                          onPointerDown={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              dragMouseDown(
                                e,
                                setPosition,
                                setHoldThisBox,
                                popupRef,
                                onUpdate,
                                scale,
                                props.data.id,
                                props.data,
                                username,
                                actionEnd,
                                true,
                              );
                              setSideDrag(true);
                            }
                          }}
                          onPointerUp={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              handleClick(e);
                            }
                          }}
                        ></div>
                      </div>
                      <div
                        data-side="bottom"
                        className={`${sideWidget ? "sideBtn" : ""}`}
                        data-interaction-target-type={true}
                      >
                        <div
                          className="side-resize-btn"
                          onPointerDown={e =>
                            resizeMouseDown(
                              e,
                              "bottom",
                              sideWidget,
                              minSize,
                              setSize,
                              setPosition,
                              setHoldThisBox,
                              popupRef,
                              onUpdate,
                              scale,
                              props.data.id,
                              props.data,
                              username,
                              actionEnd,
                            )
                          }
                          data-interaction-target-type="widget"
                          data-interaction-ignore-drag="false"
                          style={{
                            display:
                              sideDrag ||
                              (props.data.selected &&
                                selfDisplay &&
                                screenData.screenWidth > 1 &&
                                toolSwitch === "cursor")
                                ? "block"
                                : "none",
                          }}
                        ></div>
                        <div
                          className="side-resize-bar"
                          data-interaction-target-type={true}
                          onPointerDown={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              dragMouseDown(
                                e,
                                setPosition,
                                setHoldThisBox,
                                popupRef,
                                onUpdate,
                                scale,
                                props.data.id,
                                props.data,
                                username,
                                actionEnd,
                                true,
                              );
                              setSideDrag(true);
                            }
                          }}
                          onPointerUp={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              handleClick(e);
                            }
                          }}
                        ></div>
                      </div>
                      <div
                        data-side="left"
                        className={`${
                          sideWidget ||
                          sideWidget2 ||
                          (props.data.type === "WIDGET_MIND_MAP" &&
                            props.data.data.action === "edit")
                            ? "sideBtn"
                            : ""
                        }`}
                        data-interaction-target-type={true}
                      >
                        <div
                          className="side-resize-btn"
                          onPointerDown={e =>
                            resizeMouseDown(
                              e,
                              "left",
                              props.data.type !== "WIDGET_HYPERLINK" &&
                                props.data.type !== "WIDGET_TIMETABLE" &&
                                props.data.type !== "WIDGET_MIND_MAP"
                                ? sideWidget
                                : sideWidget2 ||
                                    (props.data.type === "WIDGET_MIND_MAP" &&
                                      props.data.data.action === "edit"),
                              minSize,
                              setSize,
                              setPosition,
                              setHoldThisBox,
                              popupRef,
                              onUpdate,
                              scale,
                              props.data.id,
                              props.data,
                              username,
                              actionEnd,
                            )
                          }
                          data-interaction-target-type="widget"
                          data-interaction-ignore-drag="false"
                          style={{
                            display:
                              sideDrag ||
                              (props.data.selected &&
                                selfDisplay &&
                                screenData.screenWidth > 1 &&
                                toolSwitch === "cursor")
                                ? "block"
                                : "none",
                          }}
                        ></div>
                        <div
                          className="side-resize-bar"
                          data-interaction-target-type={true}
                          onPointerDown={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              dragMouseDown(
                                e,
                                setPosition,
                                setHoldThisBox,
                                popupRef,
                                onUpdate,
                                scale,
                                props.data.id,
                                props.data,
                                username,
                                actionEnd,
                                true,
                              );
                              setSideDrag(true);
                            }
                          }}
                          onPointerUp={(e: any) => {
                            if (
                              (toolSwitch === "cursor" && !groupSelect) ||
                              (toolSwitch === "draw" && jobType !== "eraser")
                            ) {
                              handleClick(e);
                            }
                          }}
                        ></div>
                      </div>
                      <div
                        onPointerDown={e =>
                          resizeMouseDown(
                            e,
                            "top-right",
                            sideWidget,
                            minSize,
                            setSize,
                            setPosition,
                            setHoldThisBox,
                            popupRef,
                            onUpdate,
                            scale,
                            props.data.id,
                            props.data,
                            username,
                            actionEnd,
                          )
                        }
                        data-interaction-target-type="widget"
                        data-interaction-ignore-drag="false"
                        style={{
                          display:
                            sideDrag ||
                            (props.data.selected &&
                              selfDisplay &&
                              screenData.screenWidth > 1 &&
                              toolSwitch === "cursor")
                              ? "block"
                              : "none",
                        }}
                      ></div>
                      <div
                        onPointerDown={e =>
                          resizeMouseDown(
                            e,
                            "bottom-right",
                            sideWidget,
                            minSize,
                            setSize,
                            setPosition,
                            setHoldThisBox,
                            popupRef,
                            onUpdate,
                            scale,
                            props.data.id,
                            props.data,
                            username,
                            actionEnd,
                          )
                        }
                        data-interaction-target-type="widget"
                        data-interaction-ignore-drag="false"
                        style={{
                          display:
                            sideDrag ||
                            (props.data.selected &&
                              selfDisplay &&
                              screenData.screenWidth > 1 &&
                              toolSwitch === "cursor")
                              ? "block"
                              : "none",
                        }}
                      ></div>
                      <div
                        onPointerDown={e =>
                          resizeMouseDown(
                            e,
                            "bottom-left",
                            sideWidget,
                            minSize,
                            setSize,
                            setPosition,
                            setHoldThisBox,
                            popupRef,
                            onUpdate,
                            scale,
                            props.data.id,
                            props.data,
                            username,
                            actionEnd,
                          )
                        }
                        data-interaction-target-type="widget"
                        data-interaction-ignore-drag="false"
                        style={{
                          display:
                            sideDrag ||
                            (props.data.selected &&
                              selfDisplay &&
                              screenData.screenWidth > 1 &&
                              toolSwitch === "cursor")
                              ? "block"
                              : "none",
                        }}
                      ></div>
                      <div
                        onPointerDown={e =>
                          resizeMouseDown(
                            e,
                            "top-left",
                            sideWidget,
                            minSize,
                            setSize,
                            setPosition,
                            setHoldThisBox,
                            popupRef,
                            onUpdate,
                            scale,
                            props.data.id,
                            props.data,
                            username,
                            actionEnd,
                          )
                        }
                        data-interaction-target-type="widget"
                        data-interaction-ignore-drag="false"
                        style={{
                          display:
                            sideDrag ||
                            (props.data.selected &&
                              selfDisplay &&
                              screenData.screenWidth > 1 &&
                              toolSwitch === "cursor")
                              ? "block"
                              : "none",
                        }}
                      ></div>
                    </>
                  ) : null}
                </div>
              ) : null}
              {/*  */}
            </React.Fragment>
          ) : null}
          {/*  */}
          {isOpen && !props.data.spotlight ? (
            <Portal visible={nowPage}>
              <div
                className="settingBox fixed top-0 end-0 h-full w-screen"
                style={{ zIndex: 1000205 }}
                data-interaction-target-type={true}
              >
                <form
                  className="flex h-100 flex-col bg-screen shadow-xl pt-4"
                  onSubmit={(e: any) => {
                    e.preventDefault();
                  }}
                >
                  <div className="settingTitle">
                    <div>
                      <div className="ml-3 flex items-center justify-end">
                        <button
                          className="settingClose inline-flex cursor-pointer flex items-center justify-center rounded-full border border-gray-400 bg-screen p-[7px] font-semibold text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-offset-2 active:bg-gray-300"
                          onPointerDown={(e: any) => {
                            closeOption();
                          }}
                        >
                          <img src={close} alt="" />
                        </button>
                      </div>
                      <p className="option-head-mid crs-title">
                        <span>{props.data.title}</span>
                      </p>
                    </div>
                  </div>
                  <div className="settingContent">
                    {props.data.type === "WIDGET_RANDOM_NAME" ? (
                      <React.Fragment>
                        <div className="card-header align-items-center d-flex border-bottom">
                          <div className="ts-tab w-100 mt-4 flex">
                            <Nav
                              tabs
                              className="nav justify-content-end rounded card-header-tabs border-bottom-0 flex-wrap w-100"
                            >
                              <NavItem className="w-50 text-center">
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: cardHeaderTab === "ChooseList",
                                  })}
                                  onPointerDown={() => {
                                    cardHeaderToggle("ChooseList");
                                  }}
                                >
                                  選擇名單
                                </NavLink>
                              </NavItem>
                              <NavItem className="w-50 text-center">
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: cardHeaderTab === "Settings",
                                  })}
                                  onPointerDown={() => {
                                    cardHeaderToggle("Settings");
                                  }}
                                >
                                  設定
                                </NavLink>
                              </NavItem>
                            </Nav>
                          </div>
                        </div>
                        <CardBody>
                          <TabContent
                            activeTab={cardHeaderTab}
                            className="text-muted"
                          >
                            <TabPane tabId="ChooseList" id="ChooseList">
                              <div className="mt-4">
                                <label
                                  htmlFor="qr-code"
                                  className="crs-subtitle"
                                >
                                  {" "}
                                  抽籤名單{" "}
                                </label>
                              </div>
                              <textarea
                                ref={listRef}
                                style={{ resize: "none" }}
                                className="ts-text-area mt-2 h-40"
                                onChange={(e: any) =>
                                  setInputValue(e.target.value)
                                }
                                value={inputValue}
                              ></textarea>
                              <div className="mt-3 flex flex-row items-center">
                                <img
                                  src={notice}
                                  alt=""
                                  style={{ width: "20px" }}
                                />
                                <p className="crs-caption ml-1.5 mb-0">
                                  不同姓名請換行顯示
                                </p>
                              </div>
                              <div className="d-flex mt-4">
                                <div className="listForm form-check form-check-primary">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`recordList-${props.data.id}`}
                                    onChange={() => {
                                      setRecordThis(!recordThis);
                                    }}
                                    checked={recordThis}
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor={`recordList-${props.data.id}`}
                                  >
                                    繼續並儲存此名單
                                  </Label>
                                </div>
                                <Button
                                  className="rounded-pill ml-auto mt-2 continueBtn"
                                  variant="contained"
                                  disabled={inputValue === ""}
                                  onPointerDown={insetValueToRandom}
                                >
                                  儲存
                                </Button>
                              </div>
                              <div className="mt-4 board-refresh">
                                <label
                                  htmlFor="qr-code"
                                  className="crs-subtitle"
                                >
                                  {" "}
                                  學生名單{" "}
                                </label>
                                <div>
                                  <Button
                                    onClick={(e: any) => {
                                      dispatch(MemberListGetAction());
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 19.25 20.6"
                                      style={{ width: "24px" }}
                                    >
                                      <path
                                        d="M18.25,10a1,1,0,0,0-1,1,7.64,7.64,0,1,1-1.78-4.89l-4.23-.34a1,1,0,0,0-1.07.92,1,1,0,0,0,.91,1.08l6.25.5h.08A1,1,0,0,0,18.06,8a1,1,0,0,0,.35-.68l.5-6.25a1,1,0,1,0-2-.16l-.27,3.46A9.63,9.63,0,1,0,19.25,11,1,1,0,0,0,18.25,10Z"
                                        fill="#5d5b53"
                                      />
                                    </svg>
                                  </Button>
                                </div>
                              </div>
                              <div className="list-record">
                                <div>
                                  <div>
                                    {(members || []).map(
                                      (item: any, index: any) => (
                                        <button
                                          type="button"
                                          key={index}
                                          className="record-item btn btn-outline-dark flex items-center"
                                          onPointerDown={() =>
                                            handleChoice(item)
                                          }
                                        >
                                          <div>{item.name}</div>
                                          <div>({item.user_count})</div>
                                        </button>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </div>
                            </TabPane>
                            <TabPane tabId="Settings" id="Settings">
                              <div>
                                <p className="crs-body mt-4 mb-2">
                                  這些學生將不會再次被選擇:
                                </p>
                                <div className="rememberlist">
                                  {(props.data.data.remember || []).map(
                                    (item: any, index: any) => (
                                      <span
                                        className="rememberItem"
                                        key={index}
                                      >
                                        {item}
                                        <button
                                          type="button"
                                          onPointerDown={() =>
                                            removeRememberItem(index)
                                          }
                                        >
                                          <span className="sr-only">
                                            移除小選項
                                          </span>
                                          <img src={item_dlt} alt="" />
                                        </button>
                                      </span>
                                    ),
                                  )}
                                </div>
                                {props.data.data.remember.length !== 0 ? (
                                  <button
                                    className="setting-Delete mt-2 flex items-center justify-center events-none-inside focus-visible:outline-none border font-semibold inline-flex flex-row justify-center items-center focus-visible:ring-red-500 h-11 p-3 focus-visible:ring-offset-[3px] focus-visible:ring-[3px] crs-btn-dark cursor-pointer rounded-full crs-btn-outlined   crs-btn-theme-accent2 btn btn-secondary"
                                    type="button"
                                    onPointerDown={() => removeRemember()}
                                  >
                                    清除名單
                                  </button>
                                ) : null}
                              </div>
                              <ThemeSelect
                                themeList={themeList}
                                Theme={Theme}
                                setTheme={setTheme}
                                config={props.data}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                              />
                            </TabPane>
                          </TabContent>
                        </CardBody>
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_CARD" ? (
                      <React.Fragment>
                        <CardBody>
                          <div className="mt-4">
                            <label htmlFor="qr-code" className="crs-subtitle">
                              {" "}
                              卡片標題{" "}
                            </label>
                          </div>
                          <Input
                            className="crs-text-input !border-gray-400"
                            name={`title_${props.data.id}`}
                            type="text"
                            placeholder="輸入翻卡標題, 非必填"
                            onChange={(e: any) => setCardTitle(e.target.value)}
                            value={cardTitle}
                          />
                          <div className="mt-4">
                            <label htmlFor="qr-code" className="crs-subtitle">
                              {" "}
                              卡片內容{" "}
                            </label>
                          </div>
                          <textarea
                            ref={listRef}
                            style={{ resize: "none" }}
                            className="ts-text-area mt-2 h-40"
                            onChange={(e: any) => setCardValue(e.target.value)}
                            value={cardValue}
                          ></textarea>
                          <div className="mt-3 flex flex-row items-center">
                            <img
                              src={notice}
                              alt=""
                              style={{ width: "20px" }}
                            />
                            <p className="crs-caption ml-1.5 mb-0">
                              不同詞句請換行顯示
                            </p>
                          </div>
                          <div className="d-flex mt-4">
                            <div className="listForm form-check form-check-primary">
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                id={`cardList-${props.data.id}`}
                                onChange={() => {
                                  setRecordThis(!recordThis);
                                }}
                                checked={recordThis}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor={`cardList-${props.data.id}`}
                              >
                                繼續並儲存卡片資訊
                              </Label>
                            </div>
                            <Button
                              className="rounded-pill ml-auto mt-2 continueBtn"
                              variant="contained"
                              disabled={cardValue === ""}
                              onPointerDown={() => {
                                insetCardValue();
                              }}
                            >
                              儲存
                            </Button>
                          </div>
                          <div className="mt-4 board-refresh">
                            <label htmlFor="qr-code" className="crs-subtitle">
                              {" "}
                              詞句名單{" "}
                            </label>
                            <div>
                              <Button
                                onClick={(e: any) => {
                                  dispatch(CardListGetAction());
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 19.25 20.6"
                                  style={{ width: "24px" }}
                                >
                                  <path
                                    d="M18.25,10a1,1,0,0,0-1,1,7.64,7.64,0,1,1-1.78-4.89l-4.23-.34a1,1,0,0,0-1.07.92,1,1,0,0,0,.91,1.08l6.25.5h.08A1,1,0,0,0,18.06,8a1,1,0,0,0,.35-.68l.5-6.25a1,1,0,1,0-2-.16l-.27,3.46A9.63,9.63,0,1,0,19.25,11,1,1,0,0,0,18.25,10Z"
                                    fill="#5d5b53"
                                  />
                                </svg>
                              </Button>
                            </div>
                          </div>
                          <div className="list-record">
                            <div>
                              <div>
                                {(cards || []).map((item: any, index: any) => (
                                  <button
                                    type="button"
                                    key={index}
                                    className="record-item btn btn-outline-dark flex items-center"
                                    onPointerDown={() => handleCardChoice(item)}
                                  >
                                    <div>{item.name}</div>
                                    <div>({item.item_count})</div>
                                  </button>
                                ))}
                              </div>
                            </div>
                          </div>
                          <ThemeSelect
                            themeList={themeList}
                            Theme={Theme}
                            setTheme={setTheme}
                            config={props.data}
                            onUpdate={onUpdate}
                            actionEnd={actionEnd}
                          />
                        </CardBody>
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_QR_CODE" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            輸入{" "}
                          </label>
                        </div>
                        <p className="crs-body mt-2">
                          輸入您的文字或網址以產生二維碼:
                        </p>
                        <textarea
                          style={{ resize: "none" }}
                          className="crs-text-area h-18 mt-2"
                          name="qr-code"
                          placeholder="在這裡輸入您的文字或網址"
                          onChange={(e: any) => {
                            setCodeValue(e.target.value);
                            setSetPending(true);
                          }}
                          defaultValue={codeValue}
                        ></textarea>
                        {SetPending ? (
                          <div className="mt-3 mb-2 flex flex-row items-center">
                            <Spinner size="sm" color="primary">
                              {" "}
                              Loading...{" "}
                            </Spinner>
                            <p className="crs-caption ml-1.5 mb-0">處理中...</p>
                          </div>
                        ) : (
                          <React.Fragment>
                            {codeValue !== "" ? (
                              <div className="mt-3 flex flex-row items-center">
                                <img
                                  src={notice}
                                  alt=""
                                  style={{ width: "20px" }}
                                />
                                <p className="crs-caption ml-1.5 mb-0">
                                  二維碼已更新
                                </p>
                              </div>
                            ) : (
                              <div className="mt-3 flex flex-row items-center">
                                <img
                                  src={notice}
                                  alt=""
                                  style={{ width: "20px" }}
                                />
                                <p className="crs-caption ml-1.5 mb-0">
                                  輸入文字或網址
                                </p>
                              </div>
                            )}
                          </React.Fragment>
                        )}
                        <div className="image-delete-switch">
                          <div className="mt-4">
                            <label htmlFor="qr-code" className="crs-subtitle">
                              {" "}
                              標題{" "}
                            </label>
                          </div>
                          <div className="form-check mt-3 mb-4">
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id={`qrcode-title-switch-${props.data.id}`}
                              onChange={(e: any) =>
                                QrTitleSwitch(e.target.checked)
                              }
                              checked={props.data.data.titleSwitch}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor={`qrcode-title-switch-${props.data.id}`}
                            >
                              顯示標題
                            </Label>
                          </div>
                        </div>
                        <Input
                          className="crs-text-input !border-gray-400"
                          name="qrcodeTitle"
                          type="text"
                          onChange={(e: any) =>
                            changeQRcodeTitle(e.target.value)
                          }
                          value={props.data.data.title}
                        />
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_IMAGE" ? (
                      <React.Fragment>
                        <div
                          className={`file-text flex items-center justify-center mt-4 ${
                            isDragging ? "dragging" : ""
                          }`}
                          onDrop={handleDrop}
                          onDragOver={handleDragOver}
                          onDragEnter={handleDragEnter}
                          onDragLeave={handleDragLeave}
                        >
                          <div className="space-y-1 text-center upload-box">
                            <img
                              className="mb-16px"
                              src={uploadIcon}
                              alt=""
                              style={{ width: "46px" }}
                            />
                            <div className="flex text-center justify-center fs-16">
                              <label
                                htmlFor={`file-upload-${props.data.id}`}
                                className="crs-link relative rounded-md"
                              >
                                <span className="fs-16 font-semibold">
                                  上傳您的檔案
                                </span>
                                <input
                                  className="sr-only"
                                  id={`file-upload-${props.data.id}`}
                                  name={`file-upload-${props.data.id}`}
                                  type="file"
                                  accept=".jpg, .jpeg, .png, .gif"
                                  multiple={true}
                                  onChange={handleFileChange}
                                />
                              </label>
                              <span className="mt-[2px] pl-1">或拖放</span>
                            </div>
                            <p className="fs-16">GIF, PNG 或 JPG 最高 25MB</p>
                          </div>
                        </div>
                        <div className="mt-4 flex w-full flex-row flex-wrap gap-2">
                          {(images || []).map((item: any, index: any) => (
                            <div
                              key={item.id}
                              id={item.id}
                              className={`relative shrink-0 overflow-hidden rounded ring-2 focus-visible:outline-none focus-visible:ring-4  focus-visible:ring-primary-500 ring-gray-300 imageList-item ${
                                props.data.data.imgId === item.id
                                  ? "selected"
                                  : ""
                              }`}
                              style={{ height: "75px", width: "132px" }}
                            >
                              <div
                                className="absolute -inset-px cursor-pointer bg-transparent"
                                onPointerDown={() => {
                                  selectedImage(item);
                                  setFitToImage(true);
                                }}
                                style={{ zIndex: 15 }}
                              ></div>
                              <img
                                className="absolute inset-0 h-100 w-100 overflow-hidden top-0"
                                style={{ zIndex: 4 }}
                                src={BASE_URL + item.path}
                                onError={e =>
                                  (e.currentTarget.src = onerrorImg)
                                }
                                alt=""
                              />
                              {showDelete ? (
                                <div
                                  className="image-delete"
                                  onPointerDown={() => deleteImage(item)}
                                  style={{
                                    "--src": `url(${Delete})`,
                                    "--hover": `url(${lightDelete})`,
                                  }}
                                ></div>
                              ) : null}
                            </div>
                          ))}
                        </div>
                        <div className="image-delete-switch">
                          <div className="mt-4">
                            <label htmlFor="qr-code" className="crs-subtitle">
                              {" "}
                              刪除圖片{" "}
                            </label>
                          </div>
                          <div className="form-check mt-3">
                            <Input
                              className="form-check-input fs-15"
                              type="checkbox"
                              id={`delete-switch-${props.data.id}`}
                              onChange={() => deleteSwitch()}
                              checked={showDelete}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor={`delete-switch-${props.data.id}`}
                            >
                              啟用刪除圖片
                            </Label>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_TEXT" ? (
                      <React.Fragment>
                        <div>
                          <div className="mt-4">
                            <label className="crs-subtitle" htmlFor="text_set">
                              {" "}
                              設定主題{" "}
                            </label>
                          </div>
                          <div className="marquee-switch">
                            <button
                              className={`marquee-tab-btn ${
                                !IsMarquee ? "active" : ""
                              }`}
                              onClick={() => {
                                setIsMarquee(false);
                                onChangeTextType("text");
                              }}
                            >
                              文章
                            </button>
                            <button
                              className={`marquee-tab-btn ${
                                IsMarquee ? "active" : ""
                              }`}
                              onClick={() => {
                                setIsMarquee(true);
                                onChangeTextType("marquee");
                              }}
                            >
                              跑馬燈
                            </button>
                          </div>
                          {IsMarquee && (
                            <div className="mt-3">
                              <div className="marquee-controls">
                                <div className="marquee-font-size">
                                  <div>文字大小</div>
                                  <input
                                    id={`marqueeSize-${props.data.id}`}
                                    type="number"
                                    value={marqueeFontSize}
                                    onChange={e => {
                                      setMarqueeFontSize(
                                        parseFloat(e.target.value),
                                      );
                                      onChangeMarqueeFontSize(
                                        parseFloat(e.target.value),
                                      );
                                    }}
                                    list={`marqueeSizelist-${props.data.id}`}
                                  />
                                  <datalist
                                    id={`marqueeSizelist-${props.data.id}`}
                                  >
                                    <option value="11"></option>
                                    <option value="13"></option>
                                    <option value="16"></option>
                                    <option value="20"></option>
                                    <option value="24"></option>
                                    <option value="32"></option>
                                    <option value="36"></option>
                                    <option value="40"></option>
                                    <option value="48"></option>
                                    <option value="56"></option>
                                    <option value="64"></option>
                                    <option value="72"></option>
                                    <option value="80"></option>
                                    <option value="96"></option>
                                    <option value="112"></option>
                                    <option value="120"></option>
                                    <option value="128"></option>
                                    <option value="144"></option>
                                    <option value="160"></option>
                                    <option value="192"></option>
                                    <option value="224"></option>
                                    <option value="256"></option>
                                    <option value="288"></option>
                                    <option value="320"></option>
                                    <option value="384"></option>
                                    <option value="448"></option>
                                    <option value="512"></option>
                                  </datalist>
                                  <div>px</div>
                                </div>
                                <div className="marquee-speed">
                                  <div>文字速度</div>
                                  <Range
                                    ref={marqueeRangeRef}
                                    values={[speed]}
                                    step={1}
                                    min={1}
                                    max={10}
                                    onChange={(range: any) => {
                                      setSpeed(parseFloat(range[0]));
                                      onChangeMarqueeSpeed(
                                        parseFloat(range[0]),
                                      );
                                    }}
                                    renderTrack={({ props, children }) => (
                                      <div
                                        onMouseDown={props.onMouseDown}
                                        onTouchStart={props.onTouchStart}
                                        style={{
                                          ...props.style,
                                          height: "36px",
                                          display: "flex",
                                          width: "100%",
                                          marginTop: "6px",
                                        }}
                                      >
                                        <div
                                          ref={props.ref}
                                          style={{
                                            height: "5px",
                                            width: "100%",
                                            borderRadius: "4px",
                                            background: getTrackBackground({
                                              values: [speed],
                                              colors: ["#ffc780", "#d1d1d1"],
                                              min: 0,
                                              max: 10,
                                            }),
                                            alignSelf: "center",
                                          }}
                                        >
                                          {children}
                                        </div>
                                      </div>
                                    )}
                                    renderThumb={({
                                      props,
                                      index,
                                      isDragged,
                                    }) => (
                                      <div
                                        {...props}
                                        className="slider-handle sliderBtn"
                                        style={{
                                          ...props.style,
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          left: `${
                                            (props["aria-valuenow"] / 10) * 100
                                          }%`,
                                        }}
                                      >
                                        <ThumbLabel
                                          rangeRef={marqueeRangeRef.current}
                                          values={[speed]}
                                          index={index}
                                        />
                                        <div
                                          style={{
                                            height: "100%",
                                            width: "100%",
                                            backgroundColor: "#ffc780",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                          }}
                                        />
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="marquee-direction">
                                  <div>跑馬燈方向</div>
                                  <div>
                                    <button
                                      className="marquee-d-btn"
                                      onClick={() =>
                                        onChangeScrollDirection("right")
                                      }
                                    >
                                      向右
                                    </button>
                                    <button
                                      className="marquee-d-btn"
                                      onClick={() =>
                                        onChangeScrollDirection("left")
                                      }
                                    >
                                      向左
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_READ" ? (
                      <ThemeSelect
                        themeList={themeList}
                        Theme={Theme}
                        setTheme={setTheme}
                        config={props.data}
                        onUpdate={onUpdate}
                        actionEnd={actionEnd}
                      />
                    ) : null}
                    {props.data.type === "WIDGET_DRAW" ? (
                      <ThemeSelect
                        themeList={themeList}
                        Theme={Theme}
                        setTheme={setTheme}
                        config={props.data}
                        onUpdate={onUpdate}
                        actionEnd={actionEnd}
                      />
                    ) : null}
                    {props.data.type === "WIDGET_TIMER" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            倒數提醒{" "}
                          </label>
                        </div>
                        <div>
                          <div className="timer-count-down">
                            <div>倒數至</div>
                            <input
                              id={`countdown-${props.data.id}`}
                              type="number"
                              value={countDownSecond}
                              onChange={e => {
                                setCountDownSecond(parseFloat(e.target.value));
                                if (e.target.value) {
                                  onChangeCountDown(
                                    parseFloat(e.target.value) < 3
                                      ? 3
                                      : parseFloat(e.target.value),
                                  );
                                }
                              }}
                              min={3}
                            />
                            <div>秒時發出提醒</div>
                          </div>
                          <span className="countdown-tips">
                            （倒數提醒的設定，最短為3秒）
                          </span>
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_CLOCK" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            時間格式{" "}
                          </label>
                        </div>
                        <div>
                          <div className="form-check mb-2">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="format"
                              id="format1"
                              defaultChecked={props.data.data.time12HourFormat}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="format1"
                              onPointerDown={() =>
                                onChangeFormat("time12HourFormat")
                              }
                            >
                              12小時制上午/下午時鐘
                            </Label>
                          </div>
                          <div className="form-check">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="format"
                              id="format2"
                              defaultChecked={props.data.data.time24HourFormat}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="format2"
                              onPointerDown={() =>
                                onChangeFormat("time24HourFormat")
                              }
                            >
                              24小時制時鐘
                            </Label>
                          </div>
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_CALENDAR" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            週的開始日{" "}
                          </label>
                        </div>
                        <div>
                          <div className="form-check mb-2">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="weekStart"
                              id="weekStart1"
                              defaultChecked={props.data.data.Monday}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="weekStart1"
                              onPointerDown={() => onChangeWeekStart("Monday")}
                            >
                              星期一
                            </Label>
                          </div>
                          <div className="form-check">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="weekStart"
                              id="weekStart2"
                              defaultChecked={props.data.data.Sunday}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="weekStart2"
                              onPointerDown={() => onChangeWeekStart("Sunday")}
                            >
                              星期日
                            </Label>
                          </div>
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_TIMETABLE" ? (
                      <React.Fragment>
                        <div className="image-delete-switch">
                          <div className="mt-4">
                            <label htmlFor="qr-code" className="crs-subtitle">
                              {" "}
                              標題{" "}
                            </label>
                          </div>
                          <div
                            className="form-check mt-3 mb-3"
                            style={{ paddingLeft: "1.7em" }}
                          >
                            <Input
                              id={`qrcode-title-switch-${props.data.id}`}
                              className="form-check-input"
                              type="checkbox"
                              onChange={(e: any) => onTimetableTitleSwitch(e)}
                              checked={props.data.data.listTitleShow}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor={`qrcode-title-switch-${props.data.id}`}
                            >
                              顯示標題
                            </Label>
                          </div>
                        </div>
                        {props.data.data.listTitleShow ? (
                          <Input
                            className="crs-text-input !border-gray-400"
                            name="itemtibleTitle"
                            type="text"
                            placeholder="今日要做什麼?"
                            onChange={(e: any) => onTimetableTitleChange(e)}
                            value={props.data.data.listTitle}
                          />
                        ) : null}
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            顯示{" "}
                          </label>
                        </div>
                        <div>
                          <div className="form-check mb-2">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="tableDisplay"
                              id="tableDisplay1"
                              value="checklist"
                              defaultChecked={
                                props.data.data.listType === "checklist"
                              }
                              onChange={onChangeTimetableType}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="tableDisplay1"
                            >
                              清單
                            </Label>
                          </div>
                          <div className="form-check mb-2">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="tableDisplay"
                              id="tableDisplay2"
                              value="timetable"
                              defaultChecked={
                                props.data.data.listType === "timetable"
                              }
                              onChange={onChangeTimetableType}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="tableDisplay2"
                            >
                              時程表
                            </Label>
                          </div>
                          {props.data.data.listType === "timetable" ? (
                            <div className="form-check">
                              <Label
                                className="form-check-label fs-16"
                                style={{ paddingLeft: "12px" }}
                              >
                                第一項活動的開始時間
                              </Label>
                              <div className="timeTable-box">
                                <select
                                  className="form-select rounded-pill mb-3"
                                  defaultValue={props.data.data.firstTime.hour}
                                  onChange={(e: any) =>
                                    onChangeTimetableFirst(e, "hour")
                                  }
                                >
                                  {[...Array(24)].map((_, i) => {
                                    const hour = i % 12 || 12;
                                    const ampm = i < 12 ? "AM" : "PM";
                                    return (
                                      <option key={i} value={i}>
                                        {`${hour} ${ampm}`}
                                      </option>
                                    );
                                  })}
                                </select>
                                <select
                                  className="form-select rounded-pill mb-3"
                                  defaultValue={
                                    props.data.data.firstTime.minutes
                                  }
                                  onChange={(e: any) =>
                                    onChangeTimetableFirst(e, "minutes")
                                  }
                                >
                                  {[...Array(60)].map((_, i) => (
                                    <option key={i} value={i}>
                                      {i.toString().padStart(2, "0")}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            活動{" "}
                          </label>
                        </div>
                        {props.data.data.timeTable.length !== 0 ? (
                          <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="droppable">
                              {(provided: any, snapshot: any): JSX.Element => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                  className="time-list-items"
                                >
                                  {props.data.data.timeTable.map(
                                    (item: any, index: number) => {
                                      const listType = props.data.data.listType;
                                      if (
                                        listType === "timetable" ||
                                        (listType === "checklist" &&
                                          item.type === "active")
                                      ) {
                                        return (
                                          <Draggable
                                            key={item.id}
                                            draggableId={`drag-${item.id}`}
                                            index={index}
                                          >
                                            {(
                                              provided: any,
                                              snapshot: any,
                                            ): JSX.Element => (
                                              <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                className={`time-list-item${
                                                  snapshot.isDragging
                                                    ? " isDragging"
                                                    : ""
                                                }`}
                                              >
                                                <div className="time-item-box">
                                                  {item.type === "active" ? (
                                                    <div
                                                      className={`time-item-title${
                                                        listType === "timetable"
                                                          ? " non-duration"
                                                          : ""
                                                      }`}
                                                    >
                                                      <Input
                                                        className="crs-text-input !border-gray-400"
                                                        type="text"
                                                        placeholder="在這裡輸入活動名稱..."
                                                        onChange={(e: any) =>
                                                          onChangeTimeTableTitle(
                                                            e,
                                                            index,
                                                          )
                                                        }
                                                        value={item.title}
                                                      />
                                                      <div
                                                        className="image-delete"
                                                        onPointerDown={() =>
                                                          deleteTimeItem(index)
                                                        }
                                                        style={{
                                                          "--src": `url(${Delete})`,
                                                          "--hover": `url(${lightDelete})`,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  ) : null}
                                                  {props.data.data.listType ===
                                                  "timetable" ? (
                                                    <div className="item-item-duration">
                                                      <div className="duration-title">
                                                        {item.type ===
                                                        "break" ? (
                                                          <span>休息時間</span>
                                                        ) : null}
                                                        <span>時長:</span>
                                                      </div>
                                                      <div
                                                        className={`duration-input${
                                                          item.type !== "break"
                                                            ? " non-break"
                                                            : ""
                                                        }`}
                                                      >
                                                        <div className="time-duration-input">
                                                          <Label htmlFor="durationInput">
                                                            分鐘
                                                          </Label>
                                                          <Input
                                                            id="durationInput"
                                                            className="crs-text-input !border-gray-400"
                                                            type="number"
                                                            onChange={(
                                                              e: any,
                                                            ) =>
                                                              onChangeDuration(
                                                                e,
                                                                index,
                                                              )
                                                            }
                                                            value={
                                                              item.duration
                                                            }
                                                          />
                                                        </div>
                                                        <Button
                                                          className="time-duration-btn"
                                                          color="success"
                                                          onPointerDown={(
                                                            e: any,
                                                          ) =>
                                                            onClickChangeDuration(
                                                              e,
                                                              "minus",
                                                              index,
                                                            )
                                                          }
                                                        >
                                                          <span>-5</span>
                                                        </Button>
                                                        <Button
                                                          className="time-duration-btn"
                                                          color="success"
                                                          onPointerDown={(
                                                            e: any,
                                                          ) =>
                                                            onClickChangeDuration(
                                                              e,
                                                              "plus",
                                                              index,
                                                            )
                                                          }
                                                        >
                                                          <span>+5</span>
                                                        </Button>
                                                        {item.type ===
                                                        "break" ? (
                                                          <div
                                                            className="image-delete"
                                                            onPointerDown={() =>
                                                              deleteTimeItem(
                                                                index,
                                                              )
                                                            }
                                                            style={{
                                                              "--src": `url(${Delete})`,
                                                              "--hover": `url(${lightDelete})`,
                                                            }}
                                                          ></div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  ) : null}
                                                </div>
                                                <div
                                                  {...provided.dragHandleProps}
                                                  className="time-grab-side"
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 192 512"
                                                  >
                                                    {/* <!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--> */}
                                                    <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z" />
                                                  </svg>
                                                </div>
                                              </div>
                                            )}
                                          </Draggable>
                                        );
                                      }
                                      return null;
                                    },
                                  )}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                        ) : (
                          <Label className="form-check-label fs-16 non-timetable">
                            目前沒有任何活動，請創建您的第一個活動
                          </Label>
                        )}
                        <div className="timetable-btn">
                          <Button
                            variant="contained"
                            className="btn-load rounded-pill text-sm h-11 font-semibold"
                            startIcon={<AddIcon />}
                            onPointerDown={() => addActiveItem("active")}
                          >
                            <div>新增活動</div>
                          </Button>
                          <Button
                            variant="contained"
                            className="btn-load rounded-pill text-sm h-11 font-semibold flat-btn"
                            startIcon={<AddIcon />}
                            onPointerDown={() => addActiveItem("break")}
                          >
                            <div>新增休息時間</div>
                          </Button>
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_GROUP_MAKER" ? (
                      <React.Fragment>
                        <div className="card-header align-items-center d-flex border-bottom">
                          <div className="ts-tab w-100 mt-4 flex">
                            <Nav
                              tabs
                              className="nav justify-content-end rounded card-header-tabs border-bottom-0 flex-wrap w-100"
                            >
                              <NavItem className="w-50 text-center">
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: cardHeaderTab === "ChooseList",
                                  })}
                                  onPointerDown={() => {
                                    cardHeaderToggle("ChooseList");
                                  }}
                                >
                                  選擇名單
                                </NavLink>
                              </NavItem>
                              <NavItem className="w-50 text-center">
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: cardHeaderTab === "Settings",
                                  })}
                                  onPointerDown={() => {
                                    cardHeaderToggle("Settings");
                                  }}
                                >
                                  設定分組數量
                                </NavLink>
                              </NavItem>
                            </Nav>
                          </div>
                        </div>
                        <CardBody>
                          <TabContent
                            activeTab={cardHeaderTab}
                            className="text-muted"
                          >
                            <TabPane tabId="ChooseList" id="ChooseList">
                              <div className="mt-4">
                                <label
                                  htmlFor="qr-code"
                                  className="crs-subtitle"
                                >
                                  {" "}
                                  分組名單{" "}
                                </label>
                              </div>
                              <textarea
                                ref={listRef}
                                style={{ resize: "none" }}
                                className="ts-text-area mt-2 h-40"
                                onChange={(e: any) =>
                                  setInputValue(e.target.value)
                                }
                                value={inputValue}
                              ></textarea>
                              <div className="mt-3 flex flex-row items-center">
                                <img
                                  src={notice}
                                  alt=""
                                  style={{ width: "20px" }}
                                />
                                <p className="crs-caption ml-1.5 mb-0">
                                  不同人名請換行顯示
                                </p>
                              </div>
                              <div className="d-flex mt-4">
                                <div className="listForm form-check form-check-primary">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`recordList-${props.data.id}`}
                                    onChange={() => {
                                      setRecordThis(!recordThis);
                                    }}
                                    checked={recordThis}
                                  />
                                  <Label
                                    className="form-check-label"
                                    htmlFor={`recordList-${props.data.id}`}
                                  >
                                    繼續並儲存此名單
                                  </Label>
                                </div>
                                <Button
                                  className="rounded-pill ml-auto mt-2 continueBtn"
                                  variant="contained"
                                  disabled={inputValue === ""}
                                  onPointerDown={insetValueToGroup}
                                >
                                  儲存
                                </Button>
                              </div>
                              <div className="mt-4 board-refresh">
                                <label
                                  htmlFor="qr-code"
                                  className="crs-subtitle"
                                >
                                  {" "}
                                  學生名單{" "}
                                </label>
                                <div>
                                  <Button
                                    onClick={(e: any) => {
                                      dispatch(MemberListGetAction());
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 19.25 20.6"
                                      style={{ width: "24px" }}
                                    >
                                      <path
                                        d="M18.25,10a1,1,0,0,0-1,1,7.64,7.64,0,1,1-1.78-4.89l-4.23-.34a1,1,0,0,0-1.07.92,1,1,0,0,0,.91,1.08l6.25.5h.08A1,1,0,0,0,18.06,8a1,1,0,0,0,.35-.68l.5-6.25a1,1,0,1,0-2-.16l-.27,3.46A9.63,9.63,0,1,0,19.25,11,1,1,0,0,0,18.25,10Z"
                                        fill="#5d5b53"
                                      />
                                    </svg>
                                  </Button>
                                </div>
                              </div>
                              <div className="list-record">
                                <div>
                                  <div>
                                    {(members || []).map(
                                      (item: any, index: any) => (
                                        <button
                                          type="button"
                                          key={index}
                                          className="record-item btn btn-outline-dark flex items-center"
                                          onPointerDown={() =>
                                            handleChoice(item)
                                          }
                                        >
                                          <div>{item.name}</div>
                                          <div>({item.user_count})</div>
                                        </button>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </div>
                            </TabPane>
                            <TabPane tabId="Settings" id="Settings">
                              <div className="mt-4">
                                <label
                                  htmlFor="qr-code"
                                  className="crs-subtitle"
                                >
                                  {" "}
                                  名單{" "}
                                </label>
                              </div>
                              <div>
                                <Range
                                  ref={rangeRef}
                                  values={[groups]}
                                  step={1}
                                  min={0}
                                  max={20}
                                  onChange={handleRangeChange}
                                  renderTrack={({ props, children }) => (
                                    <div
                                      onMouseDown={props.onMouseDown}
                                      onTouchStart={props.onTouchStart}
                                      style={{
                                        ...props.style,
                                        height: "36px",
                                        display: "flex",
                                        width: "100%",
                                        marginTop: "6px",
                                      }}
                                    >
                                      <div
                                        ref={props.ref}
                                        style={{
                                          height: "5px",
                                          width: "100%",
                                          borderRadius: "4px",
                                          background: getTrackBackground({
                                            values: [groups],
                                            colors: ["#ffc780", "#fff"],
                                            min: 0,
                                            max: 20,
                                          }),
                                          alignSelf: "center",
                                        }}
                                      >
                                        {children}
                                      </div>
                                    </div>
                                  )}
                                  renderThumb={({
                                    props,
                                    index,
                                    isDragged,
                                  }) => (
                                    <div
                                      {...props}
                                      className="slider-handle sliderBtn"
                                      style={{
                                        ...props.style,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        left: `${
                                          (props["aria-valuenow"] / 20) * 100
                                        }%`,
                                      }}
                                    >
                                      <ThumbLabel
                                        rangeRef={rangeRef.current}
                                        values={[groups]}
                                        index={index}
                                      />
                                      <div
                                        style={{
                                          height: "100%",
                                          width: "100%",
                                          backgroundColor: "#ffc780",
                                          borderRadius: "50%",
                                          overflow: "hidden",
                                        }}
                                      />
                                    </div>
                                  )}
                                />
                              </div>
                              <ThemeSelect
                                themeList={themeList}
                                Theme={Theme}
                                setTheme={setTheme}
                                config={props.data}
                                onUpdate={onUpdate}
                                actionEnd={actionEnd}
                              />
                            </TabPane>
                          </TabContent>
                        </CardBody>
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_STOPWATCH" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            時間表格式{" "}
                          </label>
                        </div>
                        <div>
                          <div className="form-check mb-2">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="timeTable"
                              id="timeTable1"
                              defaultChecked={props.data.data.Lap}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="timeTable1"
                              onPointerDown={() => onChangeTimeType("Lap")}
                            >
                              圈次
                            </Label>
                          </div>
                          <div className="form-check">
                            <Input
                              className="form-check-input fs-15"
                              type="radio"
                              name="timeTable"
                              id="timeTable2"
                              defaultChecked={props.data.data.Split}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor="timeTable2"
                              onPointerDown={() => onChangeTimeType("Split")}
                            >
                              分割時間
                            </Label>
                          </div>
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_EMBED" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="youtube" className="crs-subtitle">
                            {" "}
                            輸入{" "}
                          </label>
                        </div>
                        <p className="crs-body mt-2">請輸入您的嵌入代碼:</p>
                        <textarea
                          style={{ resize: "none" }}
                          className="crs-text-area h-48 mt-2"
                          name="youtube"
                          placeholder='<iframe src="https://www.example.com/..."></iframe>'
                          onChange={(e: any) => changeEmbedCode(e)}
                          defaultValue={codeValue}
                        ></textarea>
                        {SetPending ? (
                          <div className="mt-3 flex flex-row items-center">
                            <Spinner size="sm" color="primary">
                              {" "}
                              Loading...{" "}
                            </Spinner>
                            <p className="crs-caption ml-1.5 mb-0">處理中...</p>
                          </div>
                        ) : (
                          <React.Fragment>
                            {codeValue !== "" ? (
                              <div className="mt-3 flex flex-row items-center">
                                <i
                                  className="mdi mdi-checkbox-marked-circle-outline"
                                  style={{
                                    fontSize: "1.35rem",
                                    color: "#6265ed",
                                  }}
                                ></i>
                                <p className="crs-caption ml-1.5 mb-0">
                                  代碼已處理
                                </p>
                              </div>
                            ) : (
                              <div className="mt-3 flex flex-row items-center">
                                <img
                                  src={notice}
                                  alt=""
                                  style={{ width: "20px" }}
                                />
                                <p className="crs-caption ml-1.5 mb-0">
                                  請輸入一個 iframe
                                </p>
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_VIDEO_TIMELINE" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="youtube" className="crs-subtitle">
                            {" "}
                            輸入{" "}
                          </label>
                        </div>
                        <p className="crs-body mt-2">
                          請輸入您的 YouTube URL 或 ID 以播放影片:
                        </p>
                        <textarea
                          style={{ resize: "none" }}
                          className="crs-text-area h-48 mt-2"
                          name="youtube"
                          placeholder="https://www.youtube.com/watch?v=[id]"
                          onChange={(e: any) => {
                            setCodeValue(e.target.value);
                            setSetPending(true);
                          }}
                          defaultValue={codeValue}
                        ></textarea>
                        {SetPending ? (
                          <div className="mt-3 flex flex-row items-center">
                            <Spinner size="sm" color="primary">
                              {" "}
                              Loading...{" "}
                            </Spinner>
                            <p className="crs-caption ml-1.5 mb-0">處理中...</p>
                          </div>
                        ) : (
                          <React.Fragment>
                            {codeValue !== "" ? (
                              <div className="mt-3 flex flex-row items-center">
                                <i
                                  className="mdi mdi-checkbox-marked-circle-outline"
                                  style={{
                                    fontSize: "1.35rem",
                                    color: "#6265ed",
                                  }}
                                ></i>
                                <p className="crs-caption ml-1.5 mb-0">
                                  影片已更新
                                </p>
                              </div>
                            ) : (
                              <div className="mt-3 flex flex-row items-center">
                                <img
                                  src={notice}
                                  alt=""
                                  style={{ width: "20px" }}
                                />
                                <p className="crs-caption ml-1.5 mb-0">
                                  請輸入 YouTube 的 ID 或 URL
                                </p>
                              </div>
                            )}
                          </React.Fragment>
                        )}
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_EVENT_COUNTDOWN" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="youtube" className="crs-subtitle">
                            {" "}
                            活動{" "}
                          </label>
                        </div>
                        <div className="d-flex">
                          <Button
                            className="rounded-pill mr-auto mt-2 continueBtn"
                            variant="contained"
                            style={{ width: "150px" }}
                            onPointerDown={() => setIsCountdownOpen(true)}
                          >
                            編輯活動
                          </Button>
                        </div>
                        <div className="mt-3">
                          <div className="marquee-controls">
                            <div className="marquee-font-size">
                              <div>文字大小</div>
                              <input
                                id={`eventNameFontSize-${props.data.id}`}
                                type="number"
                                value={eventNameFontSize}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  setEventNameFontSize(
                                    parseFloat(e.target.value),
                                  );
                                  onChangeEventNameFontSize(
                                    parseFloat(e.target.value),
                                  );
                                }}
                                list={`eventNameFontSizelist-${props.data.id}`}
                              />
                              <datalist
                                id={`eventNameFontSizelist-${props.data.id}`}
                              >
                                <option value="11"></option>
                                <option value="13"></option>
                                <option value="16"></option>
                                <option value="20"></option>
                                <option value="24"></option>
                                <option value="32"></option>
                                <option value="36"></option>
                                <option value="40"></option>
                                <option value="48"></option>
                                <option value="56"></option>
                                <option value="64"></option>
                                <option value="72"></option>
                                <option value="80"></option>
                                <option value="96"></option>
                                <option value="112"></option>
                                <option value="120"></option>
                                <option value="128"></option>
                                <option value="144"></option>
                                <option value="160"></option>
                                <option value="192"></option>
                                <option value="224"></option>
                                <option value="256"></option>
                                <option value="288"></option>
                                <option value="320"></option>
                                <option value="384"></option>
                                <option value="448"></option>
                                <option value="512"></option>
                              </datalist>
                              <div>px</div>
                            </div>
                          </div>
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_HYPERLINK" ? (
                      <React.Fragment>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            超連結{" "}
                          </label>
                        </div>
                        <Accordion
                          open={LinkOpen}
                          {...{ toggle: openThis }}
                          className="accordion-dark"
                        >
                          {(props.data.data?.linkList || []).map(
                            (item: any, index: any) => (
                              <AccordionItem key={index}>
                                <AccordionHeader
                                  className="accordion-header"
                                  targetId={`${index + 1}`}
                                >
                                  {item.title}
                                </AccordionHeader>
                                <AccordionBody
                                  className="accordion-collapse bg-screen"
                                  accordionId={`${index + 1}`}
                                >
                                  <div>
                                    <label
                                      htmlFor={`title_${props.data.id}`}
                                      className="crs-subtitle"
                                    >
                                      {" "}
                                      標題{" "}
                                    </label>
                                  </div>
                                  <Input
                                    className="crs-text-input !border-gray-400"
                                    name={`title_${props.data.id}`}
                                    type="text"
                                    placeholder={item.title}
                                    onChange={(e: any) =>
                                      changeLinkTitle(e.target.value, index)
                                    }
                                    value={item.title}
                                  />
                                  <div className="mt-2">
                                    <label
                                      htmlFor={`link_${index}`}
                                      className="crs-subtitle"
                                    >
                                      {" "}
                                      網址{" "}
                                    </label>
                                  </div>
                                  <textarea
                                    style={{ resize: "none" }}
                                    className="crs-text-area h-48"
                                    name={`link_${props.data.id}`}
                                    placeholder="請在這裡輸入您的連結..."
                                    onChange={(e: any) =>
                                      getLinkPreviewData(e.target.value, index)
                                    }
                                    value={item.link}
                                  ></textarea>
                                </AccordionBody>
                              </AccordionItem>
                            ),
                          )}
                        </Accordion>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_WORKS" ? (
                      <React.Fragment>
                        <div className="mt-4 board-refresh">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            作業{" "}
                          </label>
                          <div>
                            <Button
                              onClick={(e: any) => {
                                getWorksData();
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 19.25 20.6"
                                style={{ width: "24px" }}
                              >
                                <path
                                  d="M18.25,10a1,1,0,0,0-1,1,7.64,7.64,0,1,1-1.78-4.89l-4.23-.34a1,1,0,0,0-1.07.92,1,1,0,0,0,.91,1.08l6.25.5h.08A1,1,0,0,0,18.06,8a1,1,0,0,0,.35-.68l.5-6.25a1,1,0,1,0-2-.16l-.27,3.46A9.63,9.63,0,1,0,19.25,11,1,1,0,0,0,18.25,10Z"
                                  fill="#5d5b53"
                                />
                              </svg>
                            </Button>
                          </div>
                        </div>
                        <div className="w-100 flex">
                          <select
                            className="form-select rounded-pill mb-3"
                            onChange={handleListChange}
                            value={selectedList?.id || ""}
                          >
                            <option value="">選擇指定作業</option>
                            {worksData.map((item: any, index: any) => (
                              <option key={item.id} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mt-4 mb-3">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            群組{" "}
                          </label>
                        </div>
                        {selectedList && (
                          <select
                            className="form-select rounded-pill mb-3"
                            onChange={handleZoneChange}
                            value={selectedZone?.id || ""}
                          >
                            <option value="">選擇指定群組</option>
                            {selectedList.zone_list.map(
                              (item: any, index: any) => (
                                <option key={item.id} value={item.id}>
                                  {item.title}
                                </option>
                              ),
                            )}
                          </select>
                        )}
                        <div className="mt-4 mb-3">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            學生列表{" "}
                          </label>
                        </div>
                        {selectedZone && (
                          <div>
                            {selectedZone.work_list.map(
                              (work: any, index: any) => (
                                <button
                                  key={index}
                                  className="record-item work btn btn-outline-dark flex items-center"
                                  onClick={(e: any) => {
                                    innerData(work);
                                  }}
                                  type="button"
                                >
                                  <div>{work.title}</div>
                                  <div className="work-desc">
                                    {work.description}
                                  </div>
                                </button>
                              ),
                            )}
                          </div>
                        )}
                      </React.Fragment>
                    ) : null}
                    {props.data.type === "WIDGET_MIND_MAP" ? (
                      <React.Fragment>
                        <div className="d-flex">
                          <Button
                            className="rounded-pill mr-auto mt-2 continueBtn"
                            variant="contained"
                            style={{ width: "150px" }}
                            onPointerDown={() => {
                              setMindMapEdit(true);
                              const data = props.data.data;
                              data.cooperate = cooperate ? 1 : 0;
                              data.action = "edit";
                              onUpdate({
                                id: props.data.id,
                                baseHeight: 600,
                                height: 600,
                                width: 720,
                                minHeight: 250,
                                minWidth: 250,
                                data: data,
                              });
                              actionEnd(true);
                              setMinSize({
                                minWidth: 250,
                                minHeight: 250,
                              });
                              // iframeComponentRef.current?.sendMessageToIframe(
                              //   {
                              //     type: "mindmap-get-data",
                              //   },
                              //   "edit",
                              // );
                            }}
                          >
                            編輯心智圖
                          </Button>
                        </div>
                        <div className="mt-4">
                          <label htmlFor="qr-code" className="crs-subtitle">
                            {" "}
                            設定{" "}
                          </label>
                        </div>
                        <div>
                          <div className="form-check">
                            <Input
                              className="form-check-input fs-15"
                              type="checkbox"
                              id={`cooperate-${props.data.id}`}
                              onChange={() => {
                                const newCooperateState = !cooperate;
                                setCooperate(newCooperateState);
                                if (
                                  mindMapEdit ||
                                  props.data.data.action === "edit"
                                ) {
                                  if (props.data.data.action === "edit") {
                                    setMindMapEdit(true);
                                  }
                                  iframeComponentRef.current?.sendMessageToIframe(
                                    {
                                      type: "mindmap-get-data",
                                    },
                                    newCooperateState
                                      ? "switchToCooperate"
                                      : "switchToNormal",
                                  );
                                }
                              }}
                              checked={cooperate}
                            />
                            <Label
                              className="form-check-label fs-16"
                              htmlFor={`cooperate-${props.data.id}`}
                            >
                              啟用協作
                            </Label>
                          </div>
                        </div>
                        <ThemeSelect
                          themeList={themeList}
                          Theme={Theme}
                          setTheme={setTheme}
                          config={props.data}
                          onUpdate={onUpdate}
                          actionEnd={actionEnd}
                        />
                      </React.Fragment>
                    ) : null}
                  </div>
                </form>
              </div>
            </Portal>
          ) : null}
          {/*  */}
          {props.data.spotlight ? (
            <Portal visible={nowPage}>
              <button
                className={`top-tool-btn spotlight-btn ${
                  props.data.spotlight ? "showItem" : ""
                }`}
                onPointerDown={() => {
                  itemSpotlight();
                }}
              >
                <i className="mdi mdi-close fs-28"></i>
              </button>
            </Portal>
          ) : null}
          {/*  */}
        </React.Fragment>
      ) : null}
    </>
  );
};

export default memo(BaseBlock);

const ThumbLabel = ({
  rangeRef,
  values,
  index,
}: {
  rangeRef: Range | null;
  values: number[];
  index: number;
}) => {
  const [labelValue, labelStyle] = useThumbOverlap(
    rangeRef,
    values,
    index,
    1,
    " - ",
    value => Number(value).toString(),
  );
  const stringValue = labelValue as string;
  return (
    <div
      data-label={index}
      className="slider-tooltip"
      style={{
        background: "transparent",
        color: "#4b5563",
        fontSize: "14px",
        fontWeight: 600,
        border: 0,
        top: "-24px",
        ...(labelStyle as React.CSSProperties),
      }}
    >
      {stringValue}
    </div>
  );
};
